export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any }
  /** Represents untyped JSON */
  JSON: { input: any; output: any }
}

export type Accessory = {
  __typename?: 'Accessory'
  accessory: AccessoryAccessory
  assetType: AssetType
  company: Company
  id: Scalars['ID']['output']
  optional: Scalars['Boolean']['output']
  quantity: Scalars['Float']['output']
}

export type AccessoryAccessory = AssetType | RowItem

export type AccessoryAttributes = {
  accessoryId: Scalars['ID']['input']
  accessoryType: AccessoryType
  assetTypeId: Scalars['ID']['input']
  optional: Scalars['Boolean']['input']
  quantity: Scalars['Float']['input']
}

/** The connection type for Accessory. */
export type AccessoryConnection = {
  __typename?: 'AccessoryConnection'
  /** A list of edges. */
  edges: Array<AccessoryEdge>
  /** A list of nodes. */
  nodes: Array<Accessory>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of AccessoryCreate. */
export type AccessoryCreatePayload = {
  __typename?: 'AccessoryCreatePayload'
  accessory?: Maybe<Accessory>
  errors: Array<Error>
}

/** Autogenerated return type of AccessoryDelete. */
export type AccessoryDeletePayload = {
  __typename?: 'AccessoryDeletePayload'
  accessory?: Maybe<Accessory>
  errors: Array<Error>
}

/** An edge in a connection. */
export type AccessoryEdge = {
  __typename?: 'AccessoryEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Accessory>
}

export type AccessoryFilters = {
  accessoryIdEq?: InputMaybe<Scalars['String']['input']>
  assetTypeIdEq?: InputMaybe<Scalars['String']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  optionalEq?: InputMaybe<Scalars['Boolean']['input']>
}

export enum AccessoryType {
  AssetType = 'AssetType',
  RowItem = 'RowItem',
}

export type Accommodation = {
  __typename?: 'Accommodation'
  accommodationContacts: AccommodationContactConnection
  accommodationRoomTypes: AccommodationRoomTypeConnection
  address?: Maybe<Scalars['String']['output']>
  address1?: Maybe<Scalars['String']['output']>
  address2?: Maybe<Scalars['String']['output']>
  address3?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  company: Company
  country?: Maybe<Scalars['String']['output']>
  county?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  postcode?: Maybe<Scalars['String']['output']>
}

export type AccommodationAccommodationContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<AccommodationContactFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type AccommodationAccommodationRoomTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<AccommodationRoomTypeFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type AccommodationAttributes = {
  address1?: InputMaybe<Scalars['String']['input']>
  address2?: InputMaybe<Scalars['String']['input']>
  address3?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  county?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  postcode?: InputMaybe<Scalars['String']['input']>
}

/** The connection type for Accommodation. */
export type AccommodationConnection = {
  __typename?: 'AccommodationConnection'
  /** A list of edges. */
  edges: Array<AccommodationEdge>
  /** A list of nodes. */
  nodes: Array<Accommodation>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type AccommodationContact = {
  __typename?: 'AccommodationContact'
  accommodation: Accommodation
  color: Color
  company: Company
  contactType: AccommodationContactContact
  email?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  phone?: Maybe<Scalars['String']['output']>
  user?: Maybe<User>
}

export type AccommodationContactAttributes = {
  accommodationId: Scalars['ID']['input']
  contactType: AccommodationContactContact
  email?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  postcode?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['ID']['input']>
}

/** The connection type for AccommodationContact. */
export type AccommodationContactConnection = {
  __typename?: 'AccommodationContactConnection'
  /** A list of edges. */
  edges: Array<AccommodationContactEdge>
  /** A list of nodes. */
  nodes: Array<AccommodationContact>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export enum AccommodationContactContact {
  Facilities = 'facilities',
  FrontOffice = 'front_office',
  Other = 'other',
  Security = 'security',
}

/** Autogenerated return type of AccommodationContactCreate. */
export type AccommodationContactCreatePayload = {
  __typename?: 'AccommodationContactCreatePayload'
  accommodationContact?: Maybe<AccommodationContact>
  errors: Array<Error>
}

/** Autogenerated return type of AccommodationContactDelete. */
export type AccommodationContactDeletePayload = {
  __typename?: 'AccommodationContactDeletePayload'
  accommodationContact?: Maybe<AccommodationContact>
  errors: Array<Error>
}

/** An edge in a connection. */
export type AccommodationContactEdge = {
  __typename?: 'AccommodationContactEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<AccommodationContact>
}

export type AccommodationContactFilters = {
  contactTypeEq?: InputMaybe<Scalars['String']['input']>
  emailCont?: InputMaybe<Scalars['String']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
  phoneCont?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of AccommodationContactUpdate. */
export type AccommodationContactUpdatePayload = {
  __typename?: 'AccommodationContactUpdatePayload'
  accommodationContact?: Maybe<AccommodationContact>
  errors: Array<Error>
}

/** Autogenerated return type of AccommodationCreate. */
export type AccommodationCreatePayload = {
  __typename?: 'AccommodationCreatePayload'
  accommodation?: Maybe<Accommodation>
  errors: Array<Error>
}

/** Autogenerated return type of AccommodationDelete. */
export type AccommodationDeletePayload = {
  __typename?: 'AccommodationDeletePayload'
  accommodation?: Maybe<Accommodation>
  errors: Array<Error>
}

/** An edge in a connection. */
export type AccommodationEdge = {
  __typename?: 'AccommodationEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Accommodation>
}

export type AccommodationFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
}

export type AccommodationRoomType = {
  __typename?: 'AccommodationRoomType'
  accommodation: Accommodation
  capacity?: Maybe<Scalars['Int']['output']>
  company: Company
  id: Scalars['ID']['output']
  layout?: Maybe<AccommodationRoomTypeTypes>
  name: Scalars['String']['output']
  notes?: Maybe<Scalars['String']['output']>
}

export type AccommodationRoomTypeAttributes = {
  accommodationId: Scalars['ID']['input']
  capacity?: InputMaybe<Scalars['Int']['input']>
  layout?: InputMaybe<AccommodationRoomTypeTypes>
  name: Scalars['String']['input']
  notes?: InputMaybe<Scalars['String']['input']>
}

/** The connection type for AccommodationRoomType. */
export type AccommodationRoomTypeConnection = {
  __typename?: 'AccommodationRoomTypeConnection'
  /** A list of edges. */
  edges: Array<AccommodationRoomTypeEdge>
  /** A list of nodes. */
  nodes: Array<AccommodationRoomType>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of AccommodationRoomTypeCreate. */
export type AccommodationRoomTypeCreatePayload = {
  __typename?: 'AccommodationRoomTypeCreatePayload'
  accommodationRoomType?: Maybe<AccommodationRoomType>
  errors: Array<Error>
}

/** Autogenerated return type of AccommodationRoomTypeDelete. */
export type AccommodationRoomTypeDeletePayload = {
  __typename?: 'AccommodationRoomTypeDeletePayload'
  accommodationRoomType?: Maybe<AccommodationRoomType>
  errors: Array<Error>
}

/** An edge in a connection. */
export type AccommodationRoomTypeEdge = {
  __typename?: 'AccommodationRoomTypeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<AccommodationRoomType>
}

export type AccommodationRoomTypeFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
}

export enum AccommodationRoomTypeTypes {
  Double = 'double',
  Other = 'other',
  Single = 'single',
  Twin = 'twin',
}

/** Autogenerated return type of AccommodationRoomTypeUpdate. */
export type AccommodationRoomTypeUpdatePayload = {
  __typename?: 'AccommodationRoomTypeUpdatePayload'
  accommodationRoomType?: Maybe<AccommodationRoomType>
  errors: Array<Error>
}

/** Autogenerated return type of AccommodationUpdate. */
export type AccommodationUpdatePayload = {
  __typename?: 'AccommodationUpdatePayload'
  accommodation?: Maybe<Accommodation>
  errors: Array<Error>
}

export type Asset = {
  __typename?: 'Asset'
  assetCase?: Maybe<AssetCase>
  assetType: AssetType
  barcode: Barcode
  company: Company
  customFieldValues: Array<CustomFieldValue>
  documents: Array<Document>
  events: Array<Event>
  id: Scalars['ID']['output']
  lastCompletedMaintenanceEvent?: Maybe<MaintenanceEvent>
  lastMaintenanceEvent?: Maybe<MaintenanceEvent>
  maintenanceEvents: Array<MaintenanceEvent>
  maintenanceTasks: Array<MaintenanceTask>
  mystroTestId?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  notes?: Maybe<Scalars['String']['output']>
  productAttachments: Array<Blob>
  scheduledMaintenanceEvents: Array<MaintenanceEvent>
  serialNumber?: Maybe<Scalars['String']['output']>
  warehouse?: Maybe<Warehouse>
  warehouseLocation?: Maybe<Scalars['String']['output']>
}

export type AssetAssetCaseAttributes = {
  barcode: Scalars['String']['input']
}

export type AssetAttributes = {
  assetCaseId: Scalars['ID']['input']
  assetTypeId: Scalars['ID']['input']
  mystroTestId?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  serialNumber: Scalars['String']['input']
  warehouseId: Scalars['ID']['input']
  warehouseLocation: Scalars['String']['input']
}

export type AssetCase = {
  __typename?: 'AssetCase'
  assetCount: Scalars['Int']['output']
  assets: Array<Asset>
  barcode: Barcode
  company: Company
  description?: Maybe<Scalars['String']['output']>
  documents: Array<Document>
  height?: Maybe<Scalars['Float']['output']>
  id: Scalars['ID']['output']
  length?: Maybe<Scalars['Float']['output']>
  summary?: Maybe<Scalars['String']['output']>
  warehouse?: Maybe<Warehouse>
  weight?: Maybe<Scalars['Float']['output']>
  width?: Maybe<Scalars['Float']['output']>
}

/** Autogenerated return type of AssetCaseAddAssetToCase. */
export type AssetCaseAddAssetToCasePayload = {
  __typename?: 'AssetCaseAddAssetToCasePayload'
  assetCase?: Maybe<AssetCase>
  errors: Array<Error>
}

export type AssetCaseAttributes = {
  description?: InputMaybe<Scalars['String']['input']>
  height?: InputMaybe<Scalars['Float']['input']>
  length?: InputMaybe<Scalars['Float']['input']>
  warehouseId?: InputMaybe<Scalars['ID']['input']>
  weight?: InputMaybe<Scalars['Float']['input']>
  width?: InputMaybe<Scalars['Float']['input']>
}

/** The connection type for AssetCase. */
export type AssetCaseConnection = {
  __typename?: 'AssetCaseConnection'
  /** A list of edges. */
  edges: Array<AssetCaseEdge>
  /** A list of nodes. */
  nodes: Array<AssetCase>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of AssetCaseCreate. */
export type AssetCaseCreatePayload = {
  __typename?: 'AssetCaseCreatePayload'
  assetCase?: Maybe<AssetCase>
  errors: Array<Error>
}

/** Autogenerated return type of AssetCaseDelete. */
export type AssetCaseDeletePayload = {
  __typename?: 'AssetCaseDeletePayload'
  assetCase?: Maybe<AssetCase>
  errors: Array<Error>
}

/** An edge in a connection. */
export type AssetCaseEdge = {
  __typename?: 'AssetCaseEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<AssetCase>
}

export type AssetCaseFilters = {
  descriptionEq?: InputMaybe<Scalars['String']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
}

export type AssetCaseOrder = {
  barcode?: InputMaybe<SortOrder>
}

/** Autogenerated return type of AssetCaseRemoveAssetFromCase. */
export type AssetCaseRemoveAssetFromCasePayload = {
  __typename?: 'AssetCaseRemoveAssetFromCasePayload'
  assetCase?: Maybe<AssetCase>
  errors: Array<Error>
}

/** Autogenerated return type of AssetCaseUpdate. */
export type AssetCaseUpdatePayload = {
  __typename?: 'AssetCaseUpdatePayload'
  assetCase?: Maybe<AssetCase>
  errors: Array<Error>
}

/** The connection type for Asset. */
export type AssetConnection = {
  __typename?: 'AssetConnection'
  count: Scalars['Int']['output']
  /** A list of edges. */
  edges: Array<AssetEdge>
  /** A list of nodes. */
  nodes: Array<Asset>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of AssetCreate. */
export type AssetCreatePayload = {
  __typename?: 'AssetCreatePayload'
  assets?: Maybe<Array<Asset>>
  errors: Array<Error>
}

/** Autogenerated return type of AssetDelete. */
export type AssetDeletePayload = {
  __typename?: 'AssetDeletePayload'
  asset?: Maybe<Asset>
  errors: Array<Error>
}

/** An edge in a connection. */
export type AssetEdge = {
  __typename?: 'AssetEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Asset>
}

export type AssetFilters = {
  assetCaseIdEq?: InputMaybe<Scalars['ID']['input']>
  assetTypeIdEq?: InputMaybe<Scalars['ID']['input']>
  barcodeBarcodeEq?: InputMaybe<Scalars['String']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  serialNumberEq?: InputMaybe<Scalars['String']['input']>
  warehouseIdEq?: InputMaybe<Scalars['ID']['input']>
}

export type AssetNewAttributes = {
  assetTypeId: Scalars['ID']['input']
  quantity: Scalars['Int']['input']
}

export type AssetOrder = {
  barcode?: InputMaybe<SortOrder>
}

export type AssetType = {
  __typename?: 'AssetType'
  accessories: Array<Accessory>
  assets: AssetConnection
  availableToEvents?: Maybe<Scalars['Boolean']['output']>
  categories: Array<Category>
  company: Company
  costCents?: Maybe<Scalars['Int']['output']>
  customFieldValues: Array<CustomFieldValue>
  description?: Maybe<Scalars['String']['output']>
  displayOnWebsite?: Maybe<Scalars['Boolean']['output']>
  documentCategory?: Maybe<Category>
  documents: Array<Document>
  events: Array<Event>
  id: Scalars['ID']['output']
  image?: Maybe<Blob>
  images: Array<Blob>
  mainteannceSchedules: Array<MaintenanceSchedule>
  manufacturer?: Maybe<Scalars['String']['output']>
  model?: Maybe<Scalars['String']['output']>
  multiplierTypes: Array<MultiplierType>
  mystroTestId?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  packages: Array<Package>
  productAttachments: Array<Blob>
  productSpecifications: Array<ProductSpecification>
  rateCents?: Maybe<Scalars['Int']['output']>
  returnOnInvestment: Scalars['Float']['output']
  revenueCents: Scalars['Int']['output']
  slug?: Maybe<Scalars['String']['output']>
  stockCount?: Maybe<Scalars['Int']['output']>
  taxRate?: Maybe<TaxRate>
  weight?: Maybe<Scalars['Float']['output']>
}

export type AssetTypeAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type AssetTypeCategoriesArgs = {
  root?: InputMaybe<Scalars['Boolean']['input']>
}

export type AssetTypeAttributes = {
  availableToEvents: Scalars['Boolean']['input']
  costCents: Scalars['Int']['input']
  description: Scalars['String']['input']
  displayOnWebsite: Scalars['Boolean']['input']
  documentCategoryId: Scalars['ID']['input']
  manufacturer: Scalars['String']['input']
  model: Scalars['String']['input']
  mystroTestId?: InputMaybe<Scalars['String']['input']>
  rateCents: Scalars['Int']['input']
  stockCount: Scalars['Int']['input']
  taxRateId: Scalars['ID']['input']
  weight: Scalars['Float']['input']
}

/** The connection type for AssetType. */
export type AssetTypeConnection = {
  __typename?: 'AssetTypeConnection'
  /** A list of edges. */
  edges: Array<AssetTypeEdge>
  manufacturers: Array<Scalars['String']['output']>
  models: Array<Scalars['String']['output']>
  /** A list of nodes. */
  nodes: Array<AssetType>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of AssetTypeCreate. */
export type AssetTypeCreatePayload = {
  __typename?: 'AssetTypeCreatePayload'
  assetType?: Maybe<AssetType>
  errors: Array<Error>
}

/** Autogenerated return type of AssetTypeDelete. */
export type AssetTypeDeletePayload = {
  __typename?: 'AssetTypeDeletePayload'
  assetType?: Maybe<AssetType>
  errors: Array<Error>
}

/** An edge in a connection. */
export type AssetTypeEdge = {
  __typename?: 'AssetTypeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<AssetType>
}

export type AssetTypeFilters = {
  descriptionEq?: InputMaybe<Scalars['String']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  manufacturerCont?: InputMaybe<Scalars['String']['input']>
  modelCont?: InputMaybe<Scalars['String']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
}

export type AssetTypeMaintenanceSchedule = {
  __typename?: 'AssetTypeMaintenanceSchedule'
  assetType: AssetType
  company: Company
  id: Scalars['ID']['output']
  maintenanceSchedule: MaintenanceSchedule
}

export type AssetTypeMaintenanceScheduleAttributes = {
  assetTypeId: Scalars['ID']['input']
  maintenanceScheduleId: Scalars['ID']['input']
}

/** The connection type for AssetTypeMaintenanceSchedule. */
export type AssetTypeMaintenanceScheduleConnection = {
  __typename?: 'AssetTypeMaintenanceScheduleConnection'
  /** A list of edges. */
  edges: Array<AssetTypeMaintenanceScheduleEdge>
  /** A list of nodes. */
  nodes: Array<AssetTypeMaintenanceSchedule>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of AssetTypeMaintenanceScheduleCreate. */
export type AssetTypeMaintenanceScheduleCreatePayload = {
  __typename?: 'AssetTypeMaintenanceScheduleCreatePayload'
  assetTypeMaintenanceSchedule?: Maybe<AssetTypeMaintenanceSchedule>
  errors: Array<Error>
}

/** Autogenerated return type of AssetTypeMaintenanceScheduleDelete. */
export type AssetTypeMaintenanceScheduleDeletePayload = {
  __typename?: 'AssetTypeMaintenanceScheduleDeletePayload'
  assetTypeMaintenanceSchedule?: Maybe<AssetTypeMaintenanceSchedule>
  errors: Array<Error>
}

/** An edge in a connection. */
export type AssetTypeMaintenanceScheduleEdge = {
  __typename?: 'AssetTypeMaintenanceScheduleEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<AssetTypeMaintenanceSchedule>
}

export type AssetTypeMaintenanceScheduleFilters = {
  assetTypeIdEq?: InputMaybe<Scalars['String']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
}

export type AssetTypeOrder = {
  manufacturer?: InputMaybe<SortOrder>
  model?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
}

/** Autogenerated return type of AssetTypeUpdate. */
export type AssetTypeUpdatePayload = {
  __typename?: 'AssetTypeUpdatePayload'
  assetType?: Maybe<AssetType>
  errors: Array<Error>
}

/** Autogenerated return type of AssetUpdate. */
export type AssetUpdatePayload = {
  __typename?: 'AssetUpdatePayload'
  asset?: Maybe<Asset>
  errors: Array<Error>
}

export type Attachment = {
  __typename?: 'Attachment'
  company: Company
  filename: Scalars['String']['output']
  id: Scalars['ID']['output']
  resource: AttachmentResource
  url: Scalars['String']['output']
}

export type AttachmentAttributes = {
  key: Scalars['String']['input']
  resourceId: Scalars['ID']['input']
  resourceType: AttachmentResourceType
  signedId: Scalars['ID']['input']
}

/** The connection type for Attachment. */
export type AttachmentConnection = {
  __typename?: 'AttachmentConnection'
  /** A list of edges. */
  edges: Array<AttachmentEdge>
  /** A list of nodes. */
  nodes: Array<Attachment>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of AttachmentCreate. */
export type AttachmentCreatePayload = {
  __typename?: 'AttachmentCreatePayload'
  attachment?: Maybe<Blob>
  errors: Array<Error>
}

/** Autogenerated return type of AttachmentDelete. */
export type AttachmentDeletePayload = {
  __typename?: 'AttachmentDeletePayload'
  attachment?: Maybe<Attachment>
  errors: Array<Error>
}

/** An edge in a connection. */
export type AttachmentEdge = {
  __typename?: 'AttachmentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Attachment>
}

export type AttachmentFilters = {
  nameEq: Scalars['String']['input']
  resourceIdEq: Scalars['ID']['input']
  resourceTypeEq: AttachmentResourceType
}

export type AttachmentResource =
  | AssetType
  | Category
  | Event
  | Package
  | RowItem
  | Vehicle
  | WebsiteComponent
  | WebsitePage

export enum AttachmentResourceType {
  Asset = 'Asset',
  AssetType = 'AssetType',
  Category = 'Category',
  Event = 'Event',
  Package = 'Package',
  RowItem = 'RowItem',
  Vehicle = 'Vehicle',
  Venue = 'Venue',
}

export type Barcode = {
  __typename?: 'Barcode'
  barcode: Scalars['String']['output']
  barcodeNumber: Scalars['Int']['output']
  barcodeable: Barcodeable
  company: Company
  id: Scalars['ID']['output']
}

export type BarcodeAttributes = {
  barcodeNumber: Scalars['Int']['input']
}

/** The connection type for Barcode. */
export type BarcodeConnection = {
  __typename?: 'BarcodeConnection'
  /** A list of edges. */
  edges: Array<BarcodeEdge>
  /** A list of nodes. */
  nodes: Array<Barcode>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type BarcodeEdge = {
  __typename?: 'BarcodeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Barcode>
}

export type BarcodeFilters = {
  barcodeCont?: InputMaybe<Scalars['String']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
}

export type BarcodeOrder = {
  barcodeNumber?: InputMaybe<SortOrder>
}

/** Autogenerated return type of BarcodeUpdate. */
export type BarcodeUpdatePayload = {
  __typename?: 'BarcodeUpdatePayload'
  barcode?: Maybe<Barcode>
  errors: Array<Error>
}

export type Barcodeable = Asset | AssetCase

export type Blob = {
  __typename?: 'Blob'
  company: Company
  filename: Scalars['String']['output']
  id: Scalars['ID']['output']
  url: Scalars['String']['output']
}

export type Category = {
  __typename?: 'Category'
  assetTypes: AssetTypeConnection
  categoryFields: Array<CategoryField>
  color: Color
  company: Company
  documents: Array<Document>
  fullname: Scalars['String']['output']
  id: Scalars['ID']['output']
  images: Array<Blob>
  mystroTestId?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  packages: PackageConnection
  parent?: Maybe<Category>
  slug?: Maybe<Scalars['String']['output']>
  totalAssetTypeCost: Scalars['Int']['output']
  totalAssetTypeCount: Scalars['Int']['output']
  totalReturnOnInvestment: Scalars['Int']['output']
  totalRevenue: Scalars['Int']['output']
}

export type CategoryAssetTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<AssetTypeFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type CategoryPackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<PackageFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type CategoryAttributes = {
  color?: InputMaybe<Color>
  mystroTestId?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  parentId?: InputMaybe<Scalars['ID']['input']>
}

/** The connection type for Category. */
export type CategoryConnection = {
  __typename?: 'CategoryConnection'
  /** A list of edges. */
  edges: Array<CategoryEdge>
  /** A list of nodes. */
  nodes: Array<Category>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of CategoryCreate. */
export type CategoryCreatePayload = {
  __typename?: 'CategoryCreatePayload'
  category?: Maybe<Category>
  errors: Array<Error>
}

/** Autogenerated return type of CategoryDelete. */
export type CategoryDeletePayload = {
  __typename?: 'CategoryDeletePayload'
  category?: Maybe<Category>
  errors: Array<Error>
}

/** An edge in a connection. */
export type CategoryEdge = {
  __typename?: 'CategoryEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Category>
}

export type CategoryField = {
  __typename?: 'CategoryField'
  category: Category
  company: Company
  id: Scalars['ID']['output']
  key: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
}

export type CategoryFieldValue = {
  __typename?: 'CategoryFieldValue'
  categoryField: CategoryField
  company: Company
  eventAsset: EventAsset
  id: Scalars['ID']['output']
  value?: Maybe<Scalars['String']['output']>
}

export type CategoryFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
  productCategoriesProductIdEq?: InputMaybe<Scalars['ID']['input']>
}

export type CategoryOrder = {
  name?: InputMaybe<SortOrder>
}

/** Autogenerated return type of CategoryUpdate. */
export type CategoryUpdatePayload = {
  __typename?: 'CategoryUpdatePayload'
  category?: Maybe<Category>
  errors: Array<Error>
}

export type Client = {
  __typename?: 'Client'
  address?: Maybe<Scalars['String']['output']>
  address1?: Maybe<Scalars['String']['output']>
  address2?: Maybe<Scalars['String']['output']>
  address3?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  clientType: ClientType
  company: Company
  county?: Maybe<Scalars['String']['output']>
  discount?: Maybe<Scalars['String']['output']>
  documents: DocumentConnection
  email?: Maybe<Scalars['String']['output']>
  eventLengthTotal: Scalars['Int']['output']
  events: EventConnection
  eventsCount: Scalars['Int']['output']
  id: Scalars['ID']['output']
  initials: Scalars['String']['output']
  organisationName: Scalars['String']['output']
  phone?: Maybe<Scalars['String']['output']>
  postcode?: Maybe<Scalars['String']['output']>
  totalEventDiscounts: Scalars['Int']['output']
  totalRevenue: Scalars['Int']['output']
  xeroReference?: Maybe<XeroReference>
}

export type ClientDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<DocumentFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type ClientEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<EventFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type ClientAttributes = {
  address1?: InputMaybe<Scalars['String']['input']>
  address2?: InputMaybe<Scalars['String']['input']>
  address3?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  clientTypeId: Scalars['String']['input']
  county?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  organisationName: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  postcode?: InputMaybe<Scalars['String']['input']>
}

/** The connection type for Client. */
export type ClientConnection = {
  __typename?: 'ClientConnection'
  /** A list of edges. */
  edges: Array<ClientEdge>
  /** A list of nodes. */
  nodes: Array<Client>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of ClientCreate. */
export type ClientCreatePayload = {
  __typename?: 'ClientCreatePayload'
  client?: Maybe<Client>
  errors: Array<Error>
}

/** Autogenerated return type of ClientDelete. */
export type ClientDeletePayload = {
  __typename?: 'ClientDeletePayload'
  client?: Maybe<Client>
  errors: Array<Error>
}

/** An edge in a connection. */
export type ClientEdge = {
  __typename?: 'ClientEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Client>
}

export type ClientFilters = {
  clientTypeIdEq?: InputMaybe<Scalars['ID']['input']>
  emailCont?: InputMaybe<Scalars['String']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  organisationNameCont?: InputMaybe<Scalars['String']['input']>
  phoneCont?: InputMaybe<Scalars['String']['input']>
}

export type ClientOrder = {
  organisationName?: InputMaybe<SortOrder>
}

export type ClientType = {
  __typename?: 'ClientType'
  clients: Array<Client>
  color: Color
  company: Company
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type ClientTypeAttributes = {
  color: Color
  name: Scalars['String']['input']
}

/** The connection type for ClientType. */
export type ClientTypeConnection = {
  __typename?: 'ClientTypeConnection'
  /** A list of edges. */
  edges: Array<ClientTypeEdge>
  /** A list of nodes. */
  nodes: Array<ClientType>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of ClientTypeCreate. */
export type ClientTypeCreatePayload = {
  __typename?: 'ClientTypeCreatePayload'
  clientType?: Maybe<ClientType>
  errors: Array<Error>
}

/** Autogenerated return type of ClientTypeDelete. */
export type ClientTypeDeletePayload = {
  __typename?: 'ClientTypeDeletePayload'
  clientType?: Maybe<ClientType>
  errors: Array<Error>
}

/** An edge in a connection. */
export type ClientTypeEdge = {
  __typename?: 'ClientTypeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<ClientType>
}

export type ClientTypeFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
}

export type ClientTypeOrder = {
  name?: InputMaybe<SortOrder>
}

/** Autogenerated return type of ClientTypeUpdate. */
export type ClientTypeUpdatePayload = {
  __typename?: 'ClientTypeUpdatePayload'
  clientType?: Maybe<ClientType>
  errors: Array<Error>
}

/** Autogenerated return type of ClientUpdate. */
export type ClientUpdatePayload = {
  __typename?: 'ClientUpdatePayload'
  client?: Maybe<Client>
  errors: Array<Error>
}

export enum Color {
  Black = 'black',
  Blue = 'blue',
  Emerald = 'emerald',
  Gray = 'gray',
  Green = 'green',
  Indigo = 'indigo',
  Lime = 'lime',
  Orange = 'orange',
  Pink = 'pink',
  Purple = 'purple',
  Red = 'red',
  Sky = 'sky',
  Teal = 'teal',
  Yellow = 'yellow',
}

export type Comment = {
  __typename?: 'Comment'
  company: Company
  content?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  resource: Event
  user?: Maybe<User>
}

export type Company = {
  __typename?: 'Company'
  address1?: Maybe<Scalars['String']['output']>
  address2?: Maybe<Scalars['String']['output']>
  address3?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  companyNumber?: Maybe<Scalars['String']['output']>
  county?: Maybe<Scalars['String']['output']>
  currency: Scalars['String']['output']
  darkLogo?: Maybe<Blob>
  domain?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  lightLogo?: Maybe<Blob>
  locale?: Maybe<Scalars['String']['output']>
  mystroEnabled?: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
  phoneNumber?: Maybe<Scalars['String']['output']>
  placeholderLogo?: Maybe<Blob>
  postcode?: Maybe<Scalars['String']['output']>
  showPricesOnWebsite?: Maybe<Scalars['Boolean']['output']>
  subscription: Subscription
  vatNumber?: Maybe<Scalars['String']['output']>
  website: Website
}

export type CompanyAttributes = {
  address1: Scalars['String']['input']
  address2: Scalars['String']['input']
  address3: Scalars['String']['input']
  city: Scalars['String']['input']
  companyNumber: Scalars['String']['input']
  county: Scalars['String']['input']
  domain: Scalars['String']['input']
  email: Scalars['String']['input']
  locale: Scalars['String']['input']
  name: Scalars['String']['input']
  phoneNumber: Scalars['String']['input']
  postcode: Scalars['String']['input']
  showPricesOnWebsite: Scalars['Boolean']['input']
  vatNumber: Scalars['String']['input']
}

/** The connection type for Company. */
export type CompanyConnection = {
  __typename?: 'CompanyConnection'
  /** A list of edges. */
  edges: Array<CompanyEdge>
  /** A list of nodes. */
  nodes: Array<Company>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type CompanyEdge = {
  __typename?: 'CompanyEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Company>
}

export type CompanyFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of CompanyUpdate. */
export type CompanyUpdatePayload = {
  __typename?: 'CompanyUpdatePayload'
  company?: Maybe<Company>
  errors: Array<Error>
}

export type CompanyUser = {
  __typename?: 'CompanyUser'
  acceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  company: Company
  id: Scalars['ID']['output']
  initiatedBy?: Maybe<User>
  role: CompanyUserRole
  user: User
}

export type CompanyUserAttributes = {
  email: Scalars['String']['input']
  role: CompanyUserRole
}

/** The connection type for CompanyUser. */
export type CompanyUserConnection = {
  __typename?: 'CompanyUserConnection'
  /** A list of edges. */
  edges: Array<CompanyUserEdge>
  /** A list of nodes. */
  nodes: Array<CompanyUser>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of CompanyUserCreate. */
export type CompanyUserCreatePayload = {
  __typename?: 'CompanyUserCreatePayload'
  companyUser?: Maybe<CompanyUser>
  errors: Array<Error>
}

/** Autogenerated return type of CompanyUserDelete. */
export type CompanyUserDeletePayload = {
  __typename?: 'CompanyUserDeletePayload'
  companyUser?: Maybe<CompanyUser>
  errors: Array<Error>
}

/** An edge in a connection. */
export type CompanyUserEdge = {
  __typename?: 'CompanyUserEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<CompanyUser>
}

export type CompanyUserFilters = {
  acceptedAtGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  acceptedAtLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  userEmailCont?: InputMaybe<Scalars['String']['input']>
  userIdEq?: InputMaybe<Scalars['ID']['input']>
}

export enum CompanyUserRole {
  Crew = 'crew',
  Staff = 'staff',
}

/** Autogenerated return type of CompanyUserUpdate. */
export type CompanyUserUpdatePayload = {
  __typename?: 'CompanyUserUpdatePayload'
  companyUser?: Maybe<CompanyUser>
  errors: Array<Error>
}

export type CustomField = {
  __typename?: 'CustomField'
  company: Company
  customFieldValues: Array<CustomFieldValue>
  enabled: Scalars['Boolean']['output']
  fieldType: CustomFieldField
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  options?: Maybe<Array<CustomFieldOption>>
  resourceType: CustomFieldResource
}

export type CustomFieldAttributes = {
  enabled: Scalars['Boolean']['input']
  fieldType: CustomFieldField
  name: Scalars['String']['input']
  resourceType: CustomFieldResource
}

/** The connection type for CustomField. */
export type CustomFieldConnection = {
  __typename?: 'CustomFieldConnection'
  /** A list of edges. */
  edges: Array<CustomFieldEdge>
  /** A list of nodes. */
  nodes: Array<CustomField>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of CustomFieldCreate. */
export type CustomFieldCreatePayload = {
  __typename?: 'CustomFieldCreatePayload'
  customField?: Maybe<CustomField>
  errors: Array<Error>
}

/** Autogenerated return type of CustomFieldDelete. */
export type CustomFieldDeletePayload = {
  __typename?: 'CustomFieldDeletePayload'
  customField?: Maybe<CustomField>
  errors: Array<Error>
}

/** An edge in a connection. */
export type CustomFieldEdge = {
  __typename?: 'CustomFieldEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<CustomField>
}

export enum CustomFieldField {
  Boolean = 'boolean',
  Select = 'select',
  Text = 'text',
}

export type CustomFieldFilters = {
  availableForEq?: InputMaybe<Scalars['ID']['input']>
  enabledEq?: InputMaybe<Scalars['Boolean']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
  resourceTypeEq?: InputMaybe<CustomFieldResource>
}

export type CustomFieldOption = {
  __typename?: 'CustomFieldOption'
  company: Company
  customField: CustomField
  id: Scalars['ID']['output']
  value: Scalars['String']['output']
}

export enum CustomFieldResource {
  Asset = 'Asset',
  AssetType = 'AssetType',
  Package = 'Package',
  Venue = 'Venue',
}

/** Autogenerated return type of CustomFieldUpdate. */
export type CustomFieldUpdatePayload = {
  __typename?: 'CustomFieldUpdatePayload'
  customField?: Maybe<CustomField>
  errors: Array<Error>
}

export type CustomFieldValue = {
  __typename?: 'CustomFieldValue'
  company: Company
  customField: CustomField
  id: Scalars['ID']['output']
  resource: CustomFieldValueResource
  resourceId: Scalars['ID']['output']
  resourceType: CustomFieldResource
  value?: Maybe<Scalars['String']['output']>
}

export type CustomFieldValueAttributes = {
  customFieldId: Scalars['ID']['input']
  resourceId: Scalars['ID']['input']
  resourceType: CustomFieldResource
  value?: InputMaybe<Scalars['String']['input']>
}

/** The connection type for CustomFieldValue. */
export type CustomFieldValueConnection = {
  __typename?: 'CustomFieldValueConnection'
  /** A list of edges. */
  edges: Array<CustomFieldValueEdge>
  /** A list of nodes. */
  nodes: Array<CustomFieldValue>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of CustomFieldValueCreate. */
export type CustomFieldValueCreatePayload = {
  __typename?: 'CustomFieldValueCreatePayload'
  customFieldValue?: Maybe<CustomFieldValue>
  errors: Array<Error>
}

/** Autogenerated return type of CustomFieldValueDelete. */
export type CustomFieldValueDeletePayload = {
  __typename?: 'CustomFieldValueDeletePayload'
  customFieldValue?: Maybe<CustomFieldValue>
  errors: Array<Error>
}

/** An edge in a connection. */
export type CustomFieldValueEdge = {
  __typename?: 'CustomFieldValueEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<CustomFieldValue>
}

export type CustomFieldValueFilters = {
  customFieldNameCont?: InputMaybe<Scalars['String']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  resourceIdEq?: InputMaybe<Scalars['ID']['input']>
  resourceTypeEq?: InputMaybe<CustomFieldResource>
  valueCont?: InputMaybe<Scalars['String']['input']>
}

export type CustomFieldValueResource = Asset | AssetType | Package | Venue

/** Autogenerated return type of CustomFieldValueUpdate. */
export type CustomFieldValueUpdatePayload = {
  __typename?: 'CustomFieldValueUpdatePayload'
  customFieldValue?: Maybe<CustomFieldValue>
  errors: Array<Error>
}

export type Document = {
  __typename?: 'Document'
  company: Company
  dateDue?: Maybe<Scalars['ISO8601DateTime']['output']>
  dateIssued?: Maybe<Scalars['ISO8601DateTime']['output']>
  documentType: DocumentType
  file?: Maybe<Blob>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  number?: Maybe<Scalars['Int']['output']>
  reference?: Maybe<Scalars['String']['output']>
  subject?: Maybe<DocumentSubject>
  subjectId?: Maybe<Scalars['ID']['output']>
  subjectType?: Maybe<DocumentSubjectType>
  url?: Maybe<Scalars['String']['output']>
}

export type DocumentAttributes = {
  dateDue?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  dateIssued?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  documentTypeId: Scalars['ID']['input']
  number?: InputMaybe<Scalars['Int']['input']>
  reference?: InputMaybe<Scalars['String']['input']>
  subjectId: Scalars['ID']['input']
  subjectType: DocumentSubjectType
}

/** The connection type for Document. */
export type DocumentConnection = {
  __typename?: 'DocumentConnection'
  /** A list of edges. */
  edges: Array<DocumentEdge>
  /** A list of nodes. */
  nodes: Array<Document>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of DocumentCreate. */
export type DocumentCreatePayload = {
  __typename?: 'DocumentCreatePayload'
  document?: Maybe<Document>
  errors: Array<Error>
}

/** Autogenerated return type of DocumentDelete. */
export type DocumentDeletePayload = {
  __typename?: 'DocumentDeletePayload'
  document?: Maybe<Document>
  errors: Array<Error>
}

/** An edge in a connection. */
export type DocumentEdge = {
  __typename?: 'DocumentEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Document>
}

export type DocumentFilters = {
  documentTypeIdEq?: InputMaybe<Scalars['ID']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  numberEq?: InputMaybe<Scalars['Int']['input']>
  referenceCont?: InputMaybe<Scalars['String']['input']>
  subjectIdEq?: InputMaybe<Scalars['ID']['input']>
  subjectTypeEq?: InputMaybe<DocumentSubjectType>
}

export type DocumentOrder = {
  dateDue?: InputMaybe<SortOrder>
  dateIssued?: InputMaybe<SortOrder>
  number?: InputMaybe<SortOrder>
  reference?: InputMaybe<SortOrder>
}

export type DocumentSubject = Asset | AssetType | Event | Package

export enum DocumentSubjectType {
  Asset = 'Asset',
  AssetType = 'AssetType',
  Event = 'Event',
  Package = 'Package',
  Venue = 'Venue',
}

export type DocumentType = {
  __typename?: 'DocumentType'
  company: Company
  crewVisible?: Maybe<Scalars['Boolean']['output']>
  dateDue?: Maybe<Scalars['Boolean']['output']>
  dateIssued?: Maybe<Scalars['Boolean']['output']>
  documentTypeBlocks?: Maybe<Array<DocumentTypeBlock>>
  documents?: Maybe<Array<Document>>
  freeagentResource?: Maybe<DocumentTypeResource>
  id: Scalars['ID']['output']
  incrementStart?: Maybe<Scalars['Int']['output']>
  incremental?: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
  nextNumber?: Maybe<Scalars['Int']['output']>
  orientation?: Maybe<DocumentTypeOrientation>
  preview?: Maybe<Blob>
  previewUrl?: Maybe<Scalars['String']['output']>
  size?: Maybe<DocumentTypeSize>
  subject: DocumentSubjectType
  xeroResource?: Maybe<DocumentTypeResource>
}

export type DocumentTypeAttributes = {
  blocks?: InputMaybe<Array<DocumentTypeBlockAttributes>>
  crewVisible?: InputMaybe<Scalars['Boolean']['input']>
  dateDue?: InputMaybe<Scalars['Boolean']['input']>
  dateIssued?: InputMaybe<Scalars['Boolean']['input']>
  freeagentResource?: InputMaybe<DocumentTypeResource>
  incrementStart?: InputMaybe<Scalars['Int']['input']>
  incremental?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
  nextNumber?: InputMaybe<Scalars['Int']['input']>
  orientation: DocumentTypeOrientation
  size: DocumentTypeSize
  subject: DocumentSubjectType
  xeroResource?: InputMaybe<DocumentTypeResource>
}

export type DocumentTypeBlock = {
  __typename?: 'DocumentTypeBlock'
  blockType: DocumentTypeBlockBlockType
  company: Company
  displayOrder: Scalars['Int']['output']
  documentType: DocumentType
  id: Scalars['ID']['output']
  margins: DocumentTypeBlockMargins
  options: DocumentTypeBlockOptions
  template?: Maybe<Scalars['String']['output']>
}

export type DocumentTypeBlockAttributes = {
  blockType: DocumentTypeBlockBlockType
  margins?: InputMaybe<DocumentTypeBlockMarginsAttributes>
  options?: InputMaybe<DocumentTypeBlockOptionsAttributes>
  template?: InputMaybe<Scalars['String']['input']>
}

export enum DocumentTypeBlockBlockType {
  Address = 'address',
  AssetList = 'asset_list',
  AssetPackList = 'asset_pack_list',
  AssetTypePackList = 'asset_type_pack_list',
  DocumentDetails = 'document_details',
  EventDetails = 'event_details',
  EventItemsTable = 'event_items_table',
  EventPatDetails = 'event_pat_details',
  EventQr = 'event_qr',
  Html = 'html',
  Logo = 'logo',
  MaintenanceHistory = 'maintenance_history',
  MaintenanceSchedules = 'maintenance_schedules',
  SpecificationsTable = 'specifications_table',
  Subtitle = 'subtitle',
  Text = 'text',
  Title = 'title',
}

export type DocumentTypeBlockMargins = {
  __typename?: 'DocumentTypeBlockMargins'
  bottom?: Maybe<Scalars['Int']['output']>
  company: Company
  id: Scalars['ID']['output']
  left?: Maybe<Scalars['Int']['output']>
  right?: Maybe<Scalars['Int']['output']>
  top?: Maybe<Scalars['Int']['output']>
}

export type DocumentTypeBlockMarginsAttributes = {
  bottom?: InputMaybe<Scalars['Int']['input']>
  left?: InputMaybe<Scalars['Int']['input']>
  right?: InputMaybe<Scalars['Int']['input']>
  top?: InputMaybe<Scalars['Int']['input']>
}

export type DocumentTypeBlockOptions = {
  __typename?: 'DocumentTypeBlockOptions'
  color?: Maybe<Color>
  company: Company
  id: Scalars['ID']['output']
}

export type DocumentTypeBlockOptionsAttributes = {
  color?: InputMaybe<Color>
}

/** The connection type for DocumentType. */
export type DocumentTypeConnection = {
  __typename?: 'DocumentTypeConnection'
  /** A list of edges. */
  edges: Array<DocumentTypeEdge>
  /** A list of nodes. */
  nodes: Array<DocumentType>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of DocumentTypeCreate. */
export type DocumentTypeCreatePayload = {
  __typename?: 'DocumentTypeCreatePayload'
  documentType?: Maybe<DocumentType>
  errors: Array<Error>
}

/** Autogenerated return type of DocumentTypeDelete. */
export type DocumentTypeDeletePayload = {
  __typename?: 'DocumentTypeDeletePayload'
  documentType?: Maybe<DocumentType>
  errors: Array<Error>
}

/** An edge in a connection. */
export type DocumentTypeEdge = {
  __typename?: 'DocumentTypeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<DocumentType>
}

export type DocumentTypeFilters = {
  documentTypeIdEq?: InputMaybe<Scalars['ID']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
  subjectEq?: InputMaybe<DocumentSubjectType>
}

export type DocumentTypeOrder = {
  name?: InputMaybe<SortOrder>
}

export enum DocumentTypeOrientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
}

export enum DocumentTypeResource {
  Invoice = 'Invoice',
}

export enum DocumentTypeSize {
  A3 = 'A3',
  A4 = 'A4',
  A5 = 'A5',
  A6 = 'A6',
}

/** Autogenerated return type of DocumentTypeUpdate. */
export type DocumentTypeUpdatePayload = {
  __typename?: 'DocumentTypeUpdatePayload'
  documentType?: Maybe<DocumentType>
  errors: Array<Error>
}

/** Autogenerated return type of DocumentUpdate. */
export type DocumentUpdatePayload = {
  __typename?: 'DocumentUpdatePayload'
  document?: Maybe<Document>
  errors: Array<Error>
}

export enum Duration {
  Day = 'day',
  Hour = 'hour',
  Month = 'month',
  Year = 'year',
}

export type Email = {
  __typename?: 'Email'
  bcc?: Maybe<Scalars['JSON']['output']>
  cc?: Maybe<Scalars['JSON']['output']>
  company: Company
  emailAttachments: Array<EmailAttachment>
  from?: Maybe<Scalars['JSON']['output']>
  id: Scalars['ID']['output']
  provider: Scalars['String']['output']
  providerId?: Maybe<Scalars['String']['output']>
  replyTo?: Maybe<Scalars['JSON']['output']>
  resource: EmailResource
  status?: Maybe<Scalars['String']['output']>
  subject: Scalars['String']['output']
  templateId: Scalars['String']['output']
  to: Scalars['JSON']['output']
  variables?: Maybe<Scalars['JSON']['output']>
}

export type EmailAttachment = {
  __typename?: 'EmailAttachment'
  attachment: Blob
  company: Company
  contentType?: Maybe<Scalars['String']['output']>
  email: Email
  filename?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
}

export type EmailResource = Comment | Company | Event | User

export type Error = {
  __typename?: 'Error'
  message: Scalars['String']['output']
  path: Scalars['String']['output']
}

export type Event = {
  __typename?: 'Event'
  assetTypes: Array<AssetType>
  assets: Array<Asset>
  categories: Array<Category>
  client: Client
  comments: Array<Comment>
  company: Company
  costCents?: Maybe<Scalars['Int']['output']>
  currency: Scalars['String']['output']
  dateEnd: Scalars['ISO8601DateTime']['output']
  dateOut: Scalars['ISO8601DateTime']['output']
  dateReturn: Scalars['ISO8601DateTime']['output']
  dateStart: Scalars['ISO8601DateTime']['output']
  description: Scalars['String']['output']
  details?: Maybe<Scalars['String']['output']>
  documents: Array<Document>
  emails: Array<Email>
  eventAssets: Array<EventAsset>
  eventContacts: EventContactConnection
  eventItems: EventItemConnection
  eventLength: Scalars['Int']['output']
  eventStages: EventStageConnection
  id: Scalars['ID']['output']
  images: Array<Blob>
  organisers: Array<User>
  packEnabled: Scalars['Boolean']['output']
  packages: Array<Package>
  portfolioPage?: Maybe<PortfolioPage>
  publicLink: Scalars['String']['output']
  rowItems: Array<RowItem>
  shifts: ShiftConnection
  state: EventState
  stripePayments: Array<StripePayment>
  totalCents?: Maybe<Scalars['Int']['output']>
  vehicles: Array<Vehicle>
  venue?: Maybe<Venue>
  warehouse?: Maybe<Warehouse>
}

export type EventEventContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<EventContactFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type EventEventItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<EventItemFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type EventEventStagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<EventStageFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type EventShiftsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<ShiftFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type EventAsset = {
  __typename?: 'EventAsset'
  asset?: Maybe<Asset>
  barcode?: Maybe<Scalars['String']['output']>
  categoryFieldValues: Array<CategoryFieldValue>
  company: Company
  event: Event
  eventAssetFieldValues: Array<EventAssetFieldValue>
  eventItem: EventItem
  id: Scalars['ID']['output']
  notes?: Maybe<Scalars['String']['output']>
  packed?: Maybe<Scalars['Boolean']['output']>
  returned?: Maybe<Scalars['Boolean']['output']>
}

export type EventAssetField = {
  __typename?: 'EventAssetField'
  company: Company
  enabled?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
}

export type EventAssetFieldValue = {
  __typename?: 'EventAssetFieldValue'
  company: Company
  eventAsset: Array<EventAsset>
  eventAssetField: Array<EventAssetField>
  id: Scalars['ID']['output']
  value?: Maybe<Scalars['String']['output']>
}

export type EventAttributes = {
  clientId: Scalars['String']['input']
  dateEnd: Scalars['ISO8601DateTime']['input']
  dateOut: Scalars['ISO8601DateTime']['input']
  dateReturn: Scalars['ISO8601DateTime']['input']
  dateStart: Scalars['ISO8601DateTime']['input']
  description: Scalars['String']['input']
  details?: InputMaybe<Scalars['String']['input']>
  state: EventState
  venueId?: InputMaybe<Scalars['String']['input']>
  warehouseId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of EventClone. */
export type EventClonePayload = {
  __typename?: 'EventClonePayload'
  errors: Array<Error>
  event?: Maybe<Event>
}

/** The connection type for Event. */
export type EventConnection = {
  __typename?: 'EventConnection'
  /** A list of edges. */
  edges: Array<EventEdge>
  /** A list of nodes. */
  nodes: Array<Event>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type EventContact = {
  __typename?: 'EventContact'
  color: Color
  company: Company
  contactType: EventContactContact
  email?: Maybe<Scalars['String']['output']>
  event: Event
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  phone?: Maybe<Scalars['String']['output']>
  user?: Maybe<User>
}

export type EventContactAttributes = {
  contactType: EventContactContact
  email?: InputMaybe<Scalars['String']['input']>
  eventId: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['ID']['input']>
}

/** The connection type for EventContact. */
export type EventContactConnection = {
  __typename?: 'EventContactConnection'
  /** A list of edges. */
  edges: Array<EventContactEdge>
  /** A list of nodes. */
  nodes: Array<EventContact>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export enum EventContactContact {
  Crew = 'crew',
  CrewManager = 'crew_manager',
  ProductionManager = 'production_manager',
  ProjectManager = 'project_manager',
  SafetyManager = 'safety_manager',
  SecurityManager = 'security_manager',
  SiteManager = 'site_manager',
}

/** Autogenerated return type of EventContactCreate. */
export type EventContactCreatePayload = {
  __typename?: 'EventContactCreatePayload'
  errors: Array<Error>
  eventContact?: Maybe<EventContact>
}

/** Autogenerated return type of EventContactDelete. */
export type EventContactDeletePayload = {
  __typename?: 'EventContactDeletePayload'
  errors: Array<Error>
  eventContact?: Maybe<EventContact>
}

/** An edge in a connection. */
export type EventContactEdge = {
  __typename?: 'EventContactEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<EventContact>
}

export type EventContactFilters = {
  contactTypeEq?: InputMaybe<Scalars['String']['input']>
  emailCont?: InputMaybe<Scalars['String']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
  phoneCont?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of EventContactUpdate. */
export type EventContactUpdatePayload = {
  __typename?: 'EventContactUpdatePayload'
  errors: Array<Error>
  eventContact?: Maybe<EventContact>
}

/** Autogenerated return type of EventCreate. */
export type EventCreatePayload = {
  __typename?: 'EventCreatePayload'
  errors: Array<Error>
  event?: Maybe<Event>
}

/** Autogenerated return type of EventDelete. */
export type EventDeletePayload = {
  __typename?: 'EventDeletePayload'
  errors: Array<Error>
  event?: Maybe<Event>
}

/** An edge in a connection. */
export type EventEdge = {
  __typename?: 'EventEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Event>
}

export type EventFilters = {
  clientIdEq?: InputMaybe<Scalars['ID']['input']>
  clientOrganisationNameCont?: InputMaybe<Scalars['String']['input']>
  dateOutLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  dateReturnGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  descriptionCont?: InputMaybe<Scalars['String']['input']>
  detailsCont?: InputMaybe<Scalars['String']['input']>
  eventItemsItemIdEq?: InputMaybe<Scalars['ID']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  stateEq?: InputMaybe<Scalars['String']['input']>
  venueIdEq?: InputMaybe<Scalars['ID']['input']>
}

export type EventItem = {
  __typename?: 'EventItem'
  company: Company
  discount: Scalars['Int']['output']
  event: Event
  eventAssets: Array<EventAsset>
  eventStage?: Maybe<EventStage>
  id: Scalars['ID']['output']
  item: Product
  notes?: Maybe<Scalars['String']['output']>
  quantity: Scalars['Float']['output']
}

export type EventItemAccessoryAttributes = {
  accessoryId: Scalars['ID']['input']
  accessoryType: AccessoryType
  quantity: Scalars['Float']['input']
}

export type EventItemAttributes = {
  accessories: Array<EventItemAccessoryAttributes>
  discount: Scalars['Int']['input']
  eventId: Scalars['ID']['input']
  eventStageId: Scalars['ID']['input']
  itemId: Scalars['ID']['input']
  itemType: Scalars['String']['input']
  notes: Scalars['String']['input']
  quantity: Scalars['Float']['input']
}

/** The connection type for EventItem. */
export type EventItemConnection = {
  __typename?: 'EventItemConnection'
  /** A list of edges. */
  edges: Array<EventItemEdge>
  /** A list of nodes. */
  nodes: Array<EventItem>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of EventItemCreate. */
export type EventItemCreatePayload = {
  __typename?: 'EventItemCreatePayload'
  errors: Array<Error>
  eventItem?: Maybe<EventItem>
}

/** Autogenerated return type of EventItemDelete. */
export type EventItemDeletePayload = {
  __typename?: 'EventItemDeletePayload'
  errors: Array<Error>
  eventItem?: Maybe<EventItem>
}

/** An edge in a connection. */
export type EventItemEdge = {
  __typename?: 'EventItemEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<EventItem>
}

export type EventItemFilters = {
  eventStageIdEq?: InputMaybe<Scalars['ID']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  itemNameCont?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of EventItemUpdate. */
export type EventItemUpdatePayload = {
  __typename?: 'EventItemUpdatePayload'
  errors: Array<Error>
  eventItem?: Maybe<EventItem>
}

export type EventOrder = {
  dateEnd?: InputMaybe<SortOrder>
  dateOut?: InputMaybe<SortOrder>
  dateReturn?: InputMaybe<SortOrder>
  dateStart?: InputMaybe<SortOrder>
}

export type EventStage = {
  __typename?: 'EventStage'
  assetTypes: Array<AssetType>
  company: Company
  event: Event
  eventItems: Array<EventItem>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  notes?: Maybe<Scalars['String']['output']>
  packages: Array<Package>
  rowItem: Array<RowItem>
  vehicles: Array<Vehicle>
}

export type EventStageAttributes = {
  eventId: Scalars['ID']['input']
  name: Scalars['String']['input']
  notes?: InputMaybe<Scalars['String']['input']>
}

/** The connection type for EventStage. */
export type EventStageConnection = {
  __typename?: 'EventStageConnection'
  /** A list of edges. */
  edges: Array<EventStageEdge>
  /** A list of nodes. */
  nodes: Array<EventStage>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of EventStageCreate. */
export type EventStageCreatePayload = {
  __typename?: 'EventStageCreatePayload'
  errors: Array<Error>
  eventStage?: Maybe<EventStage>
}

/** Autogenerated return type of EventStageDelete. */
export type EventStageDeletePayload = {
  __typename?: 'EventStageDeletePayload'
  errors: Array<Error>
  eventStage?: Maybe<EventStage>
}

/** An edge in a connection. */
export type EventStageEdge = {
  __typename?: 'EventStageEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<EventStage>
}

export type EventStageFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of EventStageUpdate. */
export type EventStageUpdatePayload = {
  __typename?: 'EventStageUpdatePayload'
  errors: Array<Error>
  eventStage?: Maybe<EventStage>
}

export enum EventState {
  Cancelled = 'cancelled',
  Confirmed = 'confirmed',
  Pending = 'pending',
}

/** Autogenerated return type of EventUpdate. */
export type EventUpdatePayload = {
  __typename?: 'EventUpdatePayload'
  errors: Array<Error>
  event?: Maybe<Event>
}

export type ExternallyReferenceable =
  | Client
  | Company
  | Document
  | Event
  | Shift
  | Subscription

export type FeatureRequest = {
  __typename?: 'FeatureRequest'
  approvedAt?: Maybe<Scalars['ISO8601Date']['output']>
  betaReleasedAt?: Maybe<Scalars['ISO8601Date']['output']>
  company: Company
  creator: Scalars['String']['output']
  description: Scalars['String']['output']
  generallyReleasedAt?: Maybe<Scalars['ISO8601Date']['output']>
  id: Scalars['ID']['output']
  startedAt?: Maybe<Scalars['ISO8601Date']['output']>
  state: FeatureRequestState
  title: Scalars['String']['output']
}

/** The connection type for FeatureRequest. */
export type FeatureRequestConnection = {
  __typename?: 'FeatureRequestConnection'
  /** A list of edges. */
  edges: Array<FeatureRequestEdge>
  /** A list of nodes. */
  nodes: Array<FeatureRequest>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type FeatureRequestEdge = {
  __typename?: 'FeatureRequestEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<FeatureRequest>
}

export type FeatureRequestFilters = {
  approvedAtNotNull?: InputMaybe<Scalars['Boolean']['input']>
  betaReleasedAtNotNull?: InputMaybe<Scalars['Boolean']['input']>
  generallyReleasedAtNotNull?: InputMaybe<Scalars['Boolean']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  startedAtNotNull?: InputMaybe<Scalars['Boolean']['input']>
  titleCont?: InputMaybe<Scalars['String']['input']>
}

export type FeatureRequestOrder = {
  approvedAt?: InputMaybe<SortOrder>
  betaReleasedAt?: InputMaybe<SortOrder>
  generallyReleasedAt?: InputMaybe<SortOrder>
  startedAt?: InputMaybe<SortOrder>
}

export enum FeatureRequestState {
  Beta = 'beta',
  Pending = 'pending',
  Planned = 'planned',
  Released = 'released',
  Started = 'started',
}

export type Integration = {
  id: Scalars['ID']['output']
  integrationProvider: IntegrationProvider
  integrationReferences: Array<IntegrationReference>
}

export type IntegrationAttributes = {
  integrationType: Scalars['String']['input']
  quickfileAccountNumber?: InputMaybe<Scalars['String']['input']>
  quickfileToken?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of IntegrationCreate. */
export type IntegrationCreatePayload = {
  __typename?: 'IntegrationCreatePayload'
  errors: Array<Error>
  integration?: Maybe<Integration>
}

/** Autogenerated return type of IntegrationDelete. */
export type IntegrationDeletePayload = {
  __typename?: 'IntegrationDeletePayload'
  errors: Array<Error>
  integration?: Maybe<Integration>
}

export type IntegrationFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  typeEq?: InputMaybe<Scalars['String']['input']>
}

export type IntegrationProvider = {
  active: Scalars['Boolean']['output']
  baseUrl?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  displayName: Scalars['String']['output']
  id: Scalars['ID']['output']
  image?: Maybe<Blob>
  integrationProviderCategory: IntegrationProviderCategory
  integrations: Array<Integration>
}

export type IntegrationProviderCategory = {
  __typename?: 'IntegrationProviderCategory'
  id: Scalars['ID']['output']
  integrationProviders: Array<IntegrationProvider>
  name: Scalars['String']['output']
}

export type IntegrationProviderCategoryIntegrationProvidersArgs = {
  order?: InputMaybe<IntegrationProviderOrder>
}

export type IntegrationProviderCategoryFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
}

export type IntegrationProviderCategoryOrder = {
  name?: InputMaybe<SortOrder>
}

export type IntegrationProviderFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  typeEq?: InputMaybe<Scalars['String']['input']>
}

export type IntegrationProviderOrder = {
  type?: InputMaybe<SortOrder>
}

export type IntegrationProvidersFreeagent = IntegrationProvider & {
  __typename?: 'IntegrationProvidersFreeagent'
  active: Scalars['Boolean']['output']
  authorizeAppUrl: Scalars['String']['output']
  baseUrl?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  displayName: Scalars['String']['output']
  id: Scalars['ID']['output']
  image?: Maybe<Blob>
  integrationProviderCategory: IntegrationProviderCategory
  integrations: Array<Integration>
}

export type IntegrationProvidersMystro = IntegrationProvider & {
  __typename?: 'IntegrationProvidersMystro'
  active: Scalars['Boolean']['output']
  authorizeAppUrl: Scalars['String']['output']
  baseUrl?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  displayName: Scalars['String']['output']
  id: Scalars['ID']['output']
  image?: Maybe<Blob>
  integrationProviderCategory: IntegrationProviderCategory
  integrations: Array<Integration>
}

export type IntegrationProvidersQuickbooks = IntegrationProvider & {
  __typename?: 'IntegrationProvidersQuickbooks'
  active: Scalars['Boolean']['output']
  authorizeAppUrl: Scalars['String']['output']
  baseUrl?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  displayName: Scalars['String']['output']
  id: Scalars['ID']['output']
  image?: Maybe<Blob>
  integrationProviderCategory: IntegrationProviderCategory
  integrations: Array<Integration>
}

export type IntegrationProvidersQuickfile = IntegrationProvider & {
  __typename?: 'IntegrationProvidersQuickfile'
  active: Scalars['Boolean']['output']
  baseUrl?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  displayName: Scalars['String']['output']
  id: Scalars['ID']['output']
  image?: Maybe<Blob>
  integrationProviderCategory: IntegrationProviderCategory
  integrations: Array<Integration>
}

export type IntegrationProvidersXero = IntegrationProvider & {
  __typename?: 'IntegrationProvidersXero'
  active: Scalars['Boolean']['output']
  authorizeAppUrl: Scalars['String']['output']
  baseUrl?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  displayName: Scalars['String']['output']
  id: Scalars['ID']['output']
  image?: Maybe<Blob>
  integrationProviderCategory: IntegrationProviderCategory
  integrations: Array<Integration>
}

export type IntegrationReference = {
  __typename?: 'IntegrationReference'
  company: Company
  foreignId: Scalars['String']['output']
  foreignUrl: Scalars['String']['output']
  id: Scalars['ID']['output']
  integration: Integration
  record: ExternallyReferenceable
}

export type IntegrationsFreeagent = Integration & {
  __typename?: 'IntegrationsFreeagent'
  company: Company
  id: Scalars['ID']['output']
  integrationProvider: IntegrationProvider
  integrationReferences: Array<IntegrationReference>
}

export type IntegrationsMystro = Integration & {
  __typename?: 'IntegrationsMystro'
  company: Company
  id: Scalars['ID']['output']
  integrationProvider: IntegrationProvider
  integrationReferences: Array<IntegrationReference>
}

export type IntegrationsQuickbooks = Integration & {
  __typename?: 'IntegrationsQuickbooks'
  company: Company
  id: Scalars['ID']['output']
  integrationProvider: IntegrationProvider
  integrationReferences: Array<IntegrationReference>
}

export type IntegrationsQuickfile = Integration & {
  __typename?: 'IntegrationsQuickfile'
  company: Company
  id: Scalars['ID']['output']
  integrationProvider: IntegrationProvider
  integrationReferences: Array<IntegrationReference>
}

export type IntegrationsXero = Integration & {
  __typename?: 'IntegrationsXero'
  company: Company
  id: Scalars['ID']['output']
  integrationProvider: IntegrationProvider
  integrationReferences: Array<IntegrationReference>
}

export type MaintenanceEvent = {
  __typename?: 'MaintenanceEvent'
  asset: Asset
  company: Company
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  details?: Maybe<Scalars['String']['output']>
  dueAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  extraData: Scalars['JSON']['output']
  id: Scalars['ID']['output']
  maintenanceSchedule?: Maybe<MaintenanceSchedule>
  maintenanceTasks: MaintenanceTaskConnection
  maintenanceType: MaintenanceType
  maintenanceTypeTaskValues: Array<MaintenanceTypeTaskValue>
  passed?: Maybe<Scalars['Boolean']['output']>
  result?: Maybe<MaintenanceEventResult>
  startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  state: MaintenanceEventState
}

export type MaintenanceEventMaintenanceTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<MaintenanceTaskFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

/** Attributes for creating a new Maintenance Event */
export type MaintenanceEventAttributes = {
  assetId: Scalars['ID']['input']
  completedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  details?: InputMaybe<Scalars['String']['input']>
  dueAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  extraData?: InputMaybe<Scalars['JSON']['input']>
  maintenanceTypeId: Scalars['ID']['input']
  result?: InputMaybe<MaintenanceEventResult>
  startedAt: Scalars['ISO8601DateTime']['input']
  state: MaintenanceEventState
  tasks?: InputMaybe<Array<MaintenanceTaskAttributes>>
}

/** The connection type for MaintenanceEvent. */
export type MaintenanceEventConnection = {
  __typename?: 'MaintenanceEventConnection'
  /** A list of edges. */
  edges: Array<MaintenanceEventEdge>
  /** A list of nodes. */
  nodes: Array<MaintenanceEvent>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of MaintenanceEventCreate. */
export type MaintenanceEventCreatePayload = {
  __typename?: 'MaintenanceEventCreatePayload'
  errors: Array<Error>
  maintenanceEvent?: Maybe<MaintenanceEvent>
}

/** An edge in a connection. */
export type MaintenanceEventEdge = {
  __typename?: 'MaintenanceEventEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<MaintenanceEvent>
}

export type MaintenanceEventFilters = {
  assetIdEq?: InputMaybe<Scalars['ID']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  overdue?: InputMaybe<Scalars['Boolean']['input']>
  stateEq?: InputMaybe<MaintenanceEventState>
  stateNotEq?: InputMaybe<MaintenanceEventState>
  upcoming?: InputMaybe<Scalars['Boolean']['input']>
}

export type MaintenanceEventOrder = {
  completedAt?: InputMaybe<SortOrder>
  dueAt?: InputMaybe<SortOrder>
  startedAt?: InputMaybe<SortOrder>
}

export enum MaintenanceEventResult {
  Failed = 'failed',
  Passed = 'passed',
  Quarantined = 'quarantined',
}

export enum MaintenanceEventState {
  Completed = 'completed',
  Pending = 'pending',
  Started = 'started',
}

/** Autogenerated return type of MaintenanceEventUpdate. */
export type MaintenanceEventUpdatePayload = {
  __typename?: 'MaintenanceEventUpdatePayload'
  errors: Array<Error>
  maintenanceEvent?: Maybe<MaintenanceEvent>
}

export type MaintenanceSchedule = {
  __typename?: 'MaintenanceSchedule'
  assetTypes?: Maybe<Array<AssetType>>
  company: Company
  details?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  maintenanceEvents?: Maybe<Array<MaintenanceEvent>>
  maintenanceType: MaintenanceType
  repeatMultiplier: Scalars['Int']['output']
  repeatPeriod: Duration
  summary: Scalars['String']['output']
}

export type MaintenanceScheduleAttributes = {
  details: Scalars['String']['input']
  maintenanceTypeId: Scalars['ID']['input']
  repeatMultiplier: Scalars['Int']['input']
  repeatPeriod: Duration
}

/** The connection type for MaintenanceSchedule. */
export type MaintenanceScheduleConnection = {
  __typename?: 'MaintenanceScheduleConnection'
  /** A list of edges. */
  edges: Array<MaintenanceScheduleEdge>
  /** A list of nodes. */
  nodes: Array<MaintenanceSchedule>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of MaintenanceScheduleCreate. */
export type MaintenanceScheduleCreatePayload = {
  __typename?: 'MaintenanceScheduleCreatePayload'
  errors: Array<Error>
  maintenanceSchedule?: Maybe<MaintenanceSchedule>
}

/** Autogenerated return type of MaintenanceScheduleDelete. */
export type MaintenanceScheduleDeletePayload = {
  __typename?: 'MaintenanceScheduleDeletePayload'
  errors: Array<Error>
  maintenanceSchedule?: Maybe<MaintenanceSchedule>
}

/** An edge in a connection. */
export type MaintenanceScheduleEdge = {
  __typename?: 'MaintenanceScheduleEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<MaintenanceSchedule>
}

export type MaintenanceScheduleFilters = {
  assetTypeIdEq?: InputMaybe<Scalars['String']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
}

/** Autogenerated return type of MaintenanceScheduleUpdate. */
export type MaintenanceScheduleUpdatePayload = {
  __typename?: 'MaintenanceScheduleUpdatePayload'
  errors: Array<Error>
  maintenanceSchedule?: Maybe<MaintenanceSchedule>
}

export type MaintenanceTask = {
  __typename?: 'MaintenanceTask'
  company: Company
  id: Scalars['ID']['output']
  maintenanceEvent: MaintenanceEvent
  maintenanceTypeTask: MaintenanceTypeTask
  result?: Maybe<Scalars['String']['output']>
}

/** Attributes for creating a new Maintenance Task */
export type MaintenanceTaskAttributes = {
  maintenanceEventId: Scalars['ID']['input']
  maintenanceTypeTaskId: Scalars['ID']['input']
  result?: InputMaybe<Scalars['String']['input']>
}

/** The connection type for MaintenanceTask. */
export type MaintenanceTaskConnection = {
  __typename?: 'MaintenanceTaskConnection'
  /** A list of edges. */
  edges: Array<MaintenanceTaskEdge>
  /** A list of nodes. */
  nodes: Array<MaintenanceTask>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of MaintenanceTaskCreate. */
export type MaintenanceTaskCreatePayload = {
  __typename?: 'MaintenanceTaskCreatePayload'
  errors: Array<Error>
  maintenanceTask?: Maybe<MaintenanceTask>
}

/** Autogenerated return type of MaintenanceTaskDelete. */
export type MaintenanceTaskDeletePayload = {
  __typename?: 'MaintenanceTaskDeletePayload'
  errors: Array<Error>
  maintenanceTask?: Maybe<MaintenanceTask>
}

/** An edge in a connection. */
export type MaintenanceTaskEdge = {
  __typename?: 'MaintenanceTaskEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<MaintenanceTask>
}

export type MaintenanceTaskFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  maintenanceEventIdEq?: InputMaybe<Scalars['ID']['input']>
}

/** Autogenerated return type of MaintenanceTaskUpdate. */
export type MaintenanceTaskUpdatePayload = {
  __typename?: 'MaintenanceTaskUpdatePayload'
  errors: Array<Error>
  maintenanceTask?: Maybe<MaintenanceTask>
}

export type MaintenanceType = {
  __typename?: 'MaintenanceType'
  color: Color
  company: Company
  id: Scalars['ID']['output']
  maintenanceEvents: Array<MaintenanceEvent>
  maintenanceSchedules: Array<MaintenanceSchedule>
  maintenanceTypeTaskValues: Array<MaintenanceTypeTaskValue>
  maintenanceTypeTasks: Array<MaintenanceTypeTask>
  name: Scalars['String']['output']
}

export type MaintenanceTypeAttributes = {
  color: Color
  name: Scalars['String']['input']
}

/** The connection type for MaintenanceType. */
export type MaintenanceTypeConnection = {
  __typename?: 'MaintenanceTypeConnection'
  /** A list of edges. */
  edges: Array<MaintenanceTypeEdge>
  /** A list of nodes. */
  nodes: Array<MaintenanceType>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of MaintenanceTypeCreate. */
export type MaintenanceTypeCreatePayload = {
  __typename?: 'MaintenanceTypeCreatePayload'
  errors: Array<Error>
  maintenanceType?: Maybe<MaintenanceType>
}

/** Autogenerated return type of MaintenanceTypeDelete. */
export type MaintenanceTypeDeletePayload = {
  __typename?: 'MaintenanceTypeDeletePayload'
  errors: Array<Error>
  maintenanceType?: Maybe<MaintenanceType>
}

/** An edge in a connection. */
export type MaintenanceTypeEdge = {
  __typename?: 'MaintenanceTypeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<MaintenanceType>
}

export type MaintenanceTypeFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
}

export type MaintenanceTypeOrder = {
  name?: InputMaybe<SortOrder>
}

export type MaintenanceTypeTask = {
  __typename?: 'MaintenanceTypeTask'
  company: Company
  id: Scalars['ID']['output']
  maintenanceTasks?: Maybe<Array<MaintenanceTask>>
  maintenanceType?: Maybe<MaintenanceType>
  maintenanceTypeTaskValues?: Maybe<Array<MaintenanceTypeTaskValue>>
  name?: Maybe<Scalars['String']['output']>
  required?: Maybe<Scalars['Boolean']['output']>
  taskType?: Maybe<MaintenanceTypeTaskTask>
}

export type MaintenanceTypeTaskAttributes = {
  maintenanceTypeId: Scalars['ID']['input']
  name: Scalars['String']['input']
  required: Scalars['Boolean']['input']
  taskType: Task
}

/** The connection type for MaintenanceTypeTask. */
export type MaintenanceTypeTaskConnection = {
  __typename?: 'MaintenanceTypeTaskConnection'
  /** A list of edges. */
  edges: Array<MaintenanceTypeTaskEdge>
  /** A list of nodes. */
  nodes: Array<MaintenanceTypeTask>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of MaintenanceTypeTaskCreate. */
export type MaintenanceTypeTaskCreatePayload = {
  __typename?: 'MaintenanceTypeTaskCreatePayload'
  errors: Array<Error>
  maintenanceTypeTask?: Maybe<MaintenanceTypeTask>
}

/** Autogenerated return type of MaintenanceTypeTaskDelete. */
export type MaintenanceTypeTaskDeletePayload = {
  __typename?: 'MaintenanceTypeTaskDeletePayload'
  errors: Array<Error>
  maintenanceTypeTask?: Maybe<MaintenanceTypeTask>
}

/** An edge in a connection. */
export type MaintenanceTypeTaskEdge = {
  __typename?: 'MaintenanceTypeTaskEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<MaintenanceTypeTask>
}

export type MaintenanceTypeTaskFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  maintenanceTypeIdEq?: InputMaybe<Scalars['ID']['input']>
}

export enum MaintenanceTypeTaskTask {
  Replacement = 'replacement',
  Test = 'test',
}

/** Autogenerated return type of MaintenanceTypeTaskUpdate. */
export type MaintenanceTypeTaskUpdatePayload = {
  __typename?: 'MaintenanceTypeTaskUpdatePayload'
  errors: Array<Error>
  maintenanceTaskType?: Maybe<MaintenanceTypeTask>
}

export type MaintenanceTypeTaskValue = {
  __typename?: 'MaintenanceTypeTaskValue'
  company: Company
  id: Scalars['ID']['output']
  maintenanceTypeTask?: Maybe<MaintenanceTypeTask>
  value?: Maybe<Scalars['String']['output']>
}

/** Autogenerated return type of MaintenanceTypeUpdate. */
export type MaintenanceTypeUpdatePayload = {
  __typename?: 'MaintenanceTypeUpdatePayload'
  errors: Array<Error>
  maintenanceType?: Maybe<MaintenanceType>
}

export type MultiplierType = {
  __typename?: 'MultiplierType'
  company: Company
  id: Scalars['ID']['output']
  multiplier: Scalars['Int']['output']
  multiplierType: Duration
  name: Scalars['String']['output']
  operandQuantity: Scalars['Int']['output']
  operandType: Duration
  products?: Maybe<Array<Product>>
  summary: Scalars['String']['output']
}

export type MultiplierTypeAttributes = {
  multiplier: Scalars['Int']['input']
  multiplierType: Duration
  name: Scalars['String']['input']
  operandQuantity: Scalars['Int']['input']
  operandType: Duration
}

/** The connection type for MultiplierType. */
export type MultiplierTypeConnection = {
  __typename?: 'MultiplierTypeConnection'
  /** A list of edges. */
  edges: Array<MultiplierTypeEdge>
  /** A list of nodes. */
  nodes: Array<MultiplierType>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of MultiplierTypeCreate. */
export type MultiplierTypeCreatePayload = {
  __typename?: 'MultiplierTypeCreatePayload'
  errors: Array<Error>
  multiplierType?: Maybe<MultiplierType>
}

/** Autogenerated return type of MultiplierTypeDelete. */
export type MultiplierTypeDeletePayload = {
  __typename?: 'MultiplierTypeDeletePayload'
  errors: Array<Error>
  multiplierType?: Maybe<MultiplierType>
}

/** An edge in a connection. */
export type MultiplierTypeEdge = {
  __typename?: 'MultiplierTypeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<MultiplierType>
}

export type MultiplierTypeFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  productIdEq?: InputMaybe<Scalars['String']['input']>
}

export type MultiplierTypeOrder = {
  name?: InputMaybe<SortOrder>
}

/** Autogenerated return type of MultiplierTypeUpdate. */
export type MultiplierTypeUpdatePayload = {
  __typename?: 'MultiplierTypeUpdatePayload'
  errors: Array<Error>
  multiplierType?: Maybe<MultiplierType>
}

export type Mutation = {
  __typename?: 'Mutation'
  addAssetToCase?: Maybe<AssetCaseAddAssetToCasePayload>
  cloneEvent?: Maybe<EventClonePayload>
  createAccessory?: Maybe<AccessoryCreatePayload>
  createAccommodation?: Maybe<AccommodationCreatePayload>
  createAccommodationContact?: Maybe<AccommodationContactCreatePayload>
  createAccommodationRoomType?: Maybe<AccommodationRoomTypeCreatePayload>
  createAsset?: Maybe<AssetCreatePayload>
  createAssetCase?: Maybe<AssetCaseCreatePayload>
  createAssetType?: Maybe<AssetTypeCreatePayload>
  createAssetTypeMaintenanceSchedule?: Maybe<AssetTypeMaintenanceScheduleCreatePayload>
  createAttachment?: Maybe<AttachmentCreatePayload>
  createCategory?: Maybe<CategoryCreatePayload>
  createClient?: Maybe<ClientCreatePayload>
  createClientType?: Maybe<ClientTypeCreatePayload>
  createCompanyUser?: Maybe<CompanyUserCreatePayload>
  createCustomField?: Maybe<CustomFieldCreatePayload>
  createCustomFieldValue?: Maybe<CustomFieldValueCreatePayload>
  createDocument?: Maybe<DocumentCreatePayload>
  createDocumentType?: Maybe<DocumentTypeCreatePayload>
  createEvent?: Maybe<EventCreatePayload>
  createEventContact?: Maybe<EventContactCreatePayload>
  createEventItem?: Maybe<EventItemCreatePayload>
  createEventStage?: Maybe<EventStageCreatePayload>
  createIntegration?: Maybe<IntegrationCreatePayload>
  createMaintenanceEvent?: Maybe<MaintenanceEventCreatePayload>
  createMaintenanceSchedule?: Maybe<MaintenanceScheduleCreatePayload>
  createMaintenanceTask?: Maybe<MaintenanceTaskCreatePayload>
  createMaintenanceType?: Maybe<MaintenanceTypeCreatePayload>
  createMaintenanceTypeTask?: Maybe<MaintenanceTypeTaskCreatePayload>
  createMultiplierType?: Maybe<MultiplierTypeCreatePayload>
  createPackage?: Maybe<PackageCreatePayload>
  createPackageAssetType?: Maybe<PackageAssetTypeCreatePayload>
  createPortfolioPage?: Maybe<PortfolioPageCreatePayload>
  createProductCategory?: Maybe<ProductCategoryCreatePayload>
  createProductMultiplierType?: Maybe<ProductMultiplierTypeCreatePayload>
  createProductSpecification?: Maybe<ProductSpecificationCreatePayload>
  createRowItem?: Maybe<RowItemCreatePayload>
  createShift?: Maybe<ShiftCreatePayload>
  createTaxRate?: Maybe<TaxRateCreatePayload>
  createVehicle?: Maybe<VehicleCreatePayload>
  createVenue?: Maybe<VenueCreatePayload>
  createVenueContact?: Maybe<VenueContactCreatePayload>
  createWarehouse?: Maybe<WarehouseCreatePayload>
  deleteAccessory?: Maybe<AccessoryDeletePayload>
  deleteAccommodation?: Maybe<AccommodationDeletePayload>
  deleteAccommodationContact?: Maybe<AccommodationContactDeletePayload>
  deleteAccommodationRoomType?: Maybe<AccommodationRoomTypeDeletePayload>
  deleteAsset?: Maybe<AssetDeletePayload>
  deleteAssetCase?: Maybe<AssetCaseDeletePayload>
  deleteAssetType?: Maybe<AssetTypeDeletePayload>
  deleteAssetTypeMaintenanceSchedule?: Maybe<AssetTypeMaintenanceScheduleDeletePayload>
  deleteAttachment?: Maybe<AttachmentDeletePayload>
  deleteCategory?: Maybe<CategoryDeletePayload>
  deleteClient?: Maybe<ClientDeletePayload>
  deleteClientType?: Maybe<ClientTypeDeletePayload>
  deleteCompanyUser?: Maybe<CompanyUserDeletePayload>
  deleteCustomField?: Maybe<CustomFieldDeletePayload>
  deleteCustomFieldValue?: Maybe<CustomFieldValueDeletePayload>
  deleteDocument?: Maybe<DocumentDeletePayload>
  deleteDocumentType?: Maybe<DocumentTypeDeletePayload>
  deleteEvent?: Maybe<EventDeletePayload>
  deleteEventContact?: Maybe<EventContactDeletePayload>
  deleteEventItem?: Maybe<EventItemDeletePayload>
  deleteEventStage?: Maybe<EventStageDeletePayload>
  deleteIntegration?: Maybe<IntegrationDeletePayload>
  deleteMaintenanceSchedule?: Maybe<MaintenanceScheduleDeletePayload>
  deleteMaintenanceTask?: Maybe<MaintenanceTaskDeletePayload>
  deleteMaintenanceType?: Maybe<MaintenanceTypeDeletePayload>
  deleteMaintenanceTypeTask?: Maybe<MaintenanceTypeTaskDeletePayload>
  deleteMultiplierType?: Maybe<MultiplierTypeDeletePayload>
  deletePackage?: Maybe<PackageDeletePayload>
  deletePackageAssetType?: Maybe<PackageAssetTypeDeletePayload>
  deletePortfolioPage?: Maybe<PortfolioPageDeletePayload>
  deleteProductCategory?: Maybe<ProductCategoryDeletePayload>
  deleteProductMultiplierType?: Maybe<ProductMultiplierTypeDeletePayload>
  deleteProductSpecification?: Maybe<ProductSpecificationDeletePayload>
  deleteRowItem?: Maybe<RowItemDeletePayload>
  deleteShift?: Maybe<ShiftDeletePayload>
  deleteTaxRate?: Maybe<TaxRateDeletePayload>
  deleteVehicle?: Maybe<VehicleDeletePayload>
  deleteVenue?: Maybe<VenueDeletePayload>
  deleteVenueContact?: Maybe<VenueContactDeletePayload>
  deleteWarehouse?: Maybe<WarehouseDeletePayload>
  removeAssetFromCase?: Maybe<AssetCaseRemoveAssetFromCasePayload>
  updateAccommodation?: Maybe<AccommodationUpdatePayload>
  updateAccommodationContact?: Maybe<AccommodationContactUpdatePayload>
  updateAccommodationRoomType?: Maybe<AccommodationRoomTypeUpdatePayload>
  updateAsset?: Maybe<AssetUpdatePayload>
  updateAssetCase?: Maybe<AssetCaseUpdatePayload>
  updateAssetType?: Maybe<AssetTypeUpdatePayload>
  updateBarcode?: Maybe<BarcodeUpdatePayload>
  updateCategory?: Maybe<CategoryUpdatePayload>
  updateClient?: Maybe<ClientUpdatePayload>
  updateClientType?: Maybe<ClientTypeUpdatePayload>
  updateCompany?: Maybe<CompanyUpdatePayload>
  updateCompanyUser?: Maybe<CompanyUserUpdatePayload>
  updateCustomField?: Maybe<CustomFieldUpdatePayload>
  updateCustomFieldValue?: Maybe<CustomFieldValueUpdatePayload>
  updateDocument?: Maybe<DocumentUpdatePayload>
  updateDocumentType?: Maybe<DocumentTypeUpdatePayload>
  updateEvent?: Maybe<EventUpdatePayload>
  updateEventContact?: Maybe<EventContactUpdatePayload>
  updateEventItem?: Maybe<EventItemUpdatePayload>
  updateEventStage?: Maybe<EventStageUpdatePayload>
  updateMaintenanceEvent?: Maybe<MaintenanceEventUpdatePayload>
  updateMaintenanceSchedule?: Maybe<MaintenanceScheduleUpdatePayload>
  updateMaintenanceTask?: Maybe<MaintenanceTaskUpdatePayload>
  updateMaintenanceType?: Maybe<MaintenanceTypeUpdatePayload>
  updateMaintenanceTypeTask?: Maybe<MaintenanceTypeTaskUpdatePayload>
  updateMultiplierType?: Maybe<MultiplierTypeUpdatePayload>
  updateNotification?: Maybe<NotificationUpdatePayload>
  updatePackage?: Maybe<PackageUpdatePayload>
  updatePackageAssetType?: Maybe<PackageAssetTypeUpdatePayload>
  updatePortfolioPage?: Maybe<PortfolioPageUpdatePayload>
  updateRowItem?: Maybe<RowItemUpdatePayload>
  updateShift?: Maybe<ShiftUpdatePayload>
  updateTaxRate?: Maybe<TaxRateUpdatePayload>
  updateVehicle?: Maybe<VehicleUpdatePayload>
  updateVenue?: Maybe<VenueUpdatePayload>
  updateVenueContact?: Maybe<VenueContactUpdatePayload>
  updateWarehouse?: Maybe<WarehouseUpdatePayload>
}

export type MutationAddAssetToCaseArgs = {
  attributes: AssetAssetCaseAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationCloneEventArgs = {
  attributes: EventAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationCreateAccessoryArgs = {
  attributes: AccessoryAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateAccommodationArgs = {
  attributes: AccommodationAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateAccommodationContactArgs = {
  attributes: AccommodationContactAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateAccommodationRoomTypeArgs = {
  attributes: AccommodationRoomTypeAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateAssetArgs = {
  attributes: AssetNewAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateAssetCaseArgs = {
  attributes: AssetCaseAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateAssetTypeArgs = {
  attributes: AssetTypeAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateAssetTypeMaintenanceScheduleArgs = {
  attributes: AssetTypeMaintenanceScheduleAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateAttachmentArgs = {
  attributes: AttachmentAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateCategoryArgs = {
  attributes: CategoryAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateClientArgs = {
  attributes: ClientAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateClientTypeArgs = {
  attributes: ClientTypeAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateCompanyUserArgs = {
  attributes: CompanyUserAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateCustomFieldArgs = {
  attributes: CustomFieldAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateCustomFieldValueArgs = {
  attributes: CustomFieldValueAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateDocumentArgs = {
  attributes: DocumentAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateDocumentTypeArgs = {
  attributes: DocumentTypeAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateEventArgs = {
  attributes: EventAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateEventContactArgs = {
  attributes: EventContactAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateEventItemArgs = {
  attributes: EventItemAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateEventStageArgs = {
  attributes: EventStageAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateIntegrationArgs = {
  attributes: IntegrationAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateMaintenanceEventArgs = {
  attributes: MaintenanceEventAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateMaintenanceScheduleArgs = {
  attributes: MaintenanceScheduleAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateMaintenanceTaskArgs = {
  attributes: MaintenanceTaskAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateMaintenanceTypeArgs = {
  attributes: MaintenanceTypeAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateMaintenanceTypeTaskArgs = {
  attributes: MaintenanceTypeTaskAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateMultiplierTypeArgs = {
  attributes: MultiplierTypeAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreatePackageArgs = {
  attributes: PackageAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreatePackageAssetTypeArgs = {
  attributes: PackageAssetTypeAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreatePortfolioPageArgs = {
  attributes: PortfolioPageAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateProductCategoryArgs = {
  attributes: ProductCategoryAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateProductMultiplierTypeArgs = {
  attributes: ProductMultiplierTypeAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateProductSpecificationArgs = {
  attributes: ProductSpecificationAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateRowItemArgs = {
  attributes: RowItemAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateShiftArgs = {
  attributes: ShiftAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateTaxRateArgs = {
  attributes: TaxRateAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateVehicleArgs = {
  attributes: VehicleAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateVenueArgs = {
  attributes: VenueAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateVenueContactArgs = {
  attributes: VenueContactAttributes
  companyId: Scalars['ID']['input']
}

export type MutationCreateWarehouseArgs = {
  attributes: WarehouseAttributes
  companyId: Scalars['ID']['input']
}

export type MutationDeleteAccessoryArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteAccommodationArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteAccommodationContactArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteAccommodationRoomTypeArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteAssetArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteAssetCaseArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteAssetTypeArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteAssetTypeMaintenanceScheduleArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteAttachmentArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteCategoryArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteClientArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteClientTypeArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteCompanyUserArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteCustomFieldArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteCustomFieldValueArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteDocumentArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteDocumentTypeArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteEventArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteEventContactArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteEventItemArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteEventStageArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteIntegrationArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteMaintenanceScheduleArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteMaintenanceTaskArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteMaintenanceTypeArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteMaintenanceTypeTaskArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteMultiplierTypeArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeletePackageArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeletePackageAssetTypeArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeletePortfolioPageArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteProductCategoryArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteProductMultiplierTypeArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteProductSpecificationArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteRowItemArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteShiftArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteTaxRateArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteVehicleArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteVenueArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteVenueContactArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationDeleteWarehouseArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationRemoveAssetFromCaseArgs = {
  attributes: AssetAssetCaseAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateAccommodationArgs = {
  attributes: AccommodationAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateAccommodationContactArgs = {
  attributes: AccommodationContactAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateAccommodationRoomTypeArgs = {
  attributes: AccommodationRoomTypeAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateAssetArgs = {
  attributes: AssetAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateAssetCaseArgs = {
  attributes: AssetCaseAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateAssetTypeArgs = {
  attributes: AssetTypeAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateBarcodeArgs = {
  attributes: BarcodeAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateCategoryArgs = {
  attributes: CategoryAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateClientArgs = {
  attributes: ClientAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateClientTypeArgs = {
  attributes: ClientTypeAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateCompanyArgs = {
  attributes: CompanyAttributes
  companyId: Scalars['ID']['input']
}

export type MutationUpdateCompanyUserArgs = {
  attributes: CompanyUserAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateCustomFieldArgs = {
  attributes: CustomFieldAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateCustomFieldValueArgs = {
  attributes: CustomFieldValueAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateDocumentArgs = {
  attributes: DocumentAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateDocumentTypeArgs = {
  attributes: DocumentTypeAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateEventArgs = {
  attributes: EventAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateEventContactArgs = {
  attributes: EventContactAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateEventItemArgs = {
  attributes: EventItemAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateEventStageArgs = {
  attributes: EventStageAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateMaintenanceEventArgs = {
  attributes: MaintenanceEventAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateMaintenanceScheduleArgs = {
  attributes: MaintenanceScheduleAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateMaintenanceTaskArgs = {
  attributes: MaintenanceTaskAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateMaintenanceTypeArgs = {
  attributes: MaintenanceTypeAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateMaintenanceTypeTaskArgs = {
  attributes: MaintenanceTypeTaskAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateMultiplierTypeArgs = {
  attributes: MultiplierTypeAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateNotificationArgs = {
  attributes: NotificationAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdatePackageArgs = {
  attributes: PackageAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdatePackageAssetTypeArgs = {
  attributes: PackageAssetTypeAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdatePortfolioPageArgs = {
  attributes: PortfolioPageAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateRowItemArgs = {
  attributes: RowItemAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateShiftArgs = {
  attributes: ShiftAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateTaxRateArgs = {
  attributes: TaxRateAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateVehicleArgs = {
  attributes: VehicleAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateVenueArgs = {
  attributes: VenueAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateVenueContactArgs = {
  attributes: VenueContactAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MutationUpdateWarehouseArgs = {
  attributes: WarehouseAttributes
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type MystroTest = {
  __typename?: 'MystroTest'
  equipmentCategoriesCount: Scalars['Int']['output']
  equipmentCount: Scalars['Int']['output']
  equipmentTypesCount: Scalars['Int']['output']
  id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type Notification = {
  __typename?: 'Notification'
  company?: Maybe<Company>
  id: Scalars['ID']['output']
  message: Scalars['String']['output']
  postedAt: Scalars['ISO8601DateTime']['output']
  readAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  title: Scalars['String']['output']
  user: User
}

export type NotificationAttributes = {
  readAt: Scalars['ISO8601DateTime']['input']
}

/** The connection type for Notification. */
export type NotificationConnection = {
  __typename?: 'NotificationConnection'
  /** A list of edges. */
  edges: Array<NotificationEdge>
  /** A list of nodes. */
  nodes: Array<Notification>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Notification>
}

export type NotificationFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  messageCont?: InputMaybe<Scalars['String']['input']>
  titleCont?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of NotificationUpdate. */
export type NotificationUpdatePayload = {
  __typename?: 'NotificationUpdatePayload'
  errors: Array<Error>
  notification?: Maybe<Notification>
}

export type Package = {
  __typename?: 'Package'
  assetTypes: Array<AssetType>
  availableToEvents?: Maybe<Scalars['Boolean']['output']>
  categories: Array<Category>
  company: Company
  costCents: Scalars['Int']['output']
  customFieldValues: Array<CustomFieldValue>
  description?: Maybe<Scalars['String']['output']>
  displayOnWebsite?: Maybe<Scalars['Boolean']['output']>
  documentCategory: Category
  documents: Array<Document>
  events: Array<Event>
  id: Scalars['ID']['output']
  images: Array<Blob>
  multiplierTypes: Array<MultiplierType>
  name: Scalars['String']['output']
  productAttachments: Array<Blob>
  productSpecifications: Array<ProductSpecification>
  rateCents?: Maybe<Scalars['Int']['output']>
  returnOnInvestment: Scalars['Float']['output']
  revenueCents: Scalars['Int']['output']
  slug?: Maybe<Scalars['String']['output']>
  taxRate: TaxRate
}

export type PackageCategoriesArgs = {
  root?: InputMaybe<Scalars['Boolean']['input']>
}

export type PackageAssetType = {
  __typename?: 'PackageAssetType'
  assetType: AssetType
  company: Company
  id: Scalars['ID']['output']
  package: Package
  quantity: Scalars['Int']['output']
}

export type PackageAssetTypeAttributes = {
  assetTypeId: Scalars['ID']['input']
  packageId: Scalars['ID']['input']
  quantity: Scalars['Int']['input']
}

/** The connection type for PackageAssetType. */
export type PackageAssetTypeConnection = {
  __typename?: 'PackageAssetTypeConnection'
  /** A list of edges. */
  edges: Array<PackageAssetTypeEdge>
  /** A list of nodes. */
  nodes: Array<PackageAssetType>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of PackageAssetTypeCreate. */
export type PackageAssetTypeCreatePayload = {
  __typename?: 'PackageAssetTypeCreatePayload'
  errors: Array<Error>
  packageAssetType?: Maybe<PackageAssetType>
}

/** Autogenerated return type of PackageAssetTypeDelete. */
export type PackageAssetTypeDeletePayload = {
  __typename?: 'PackageAssetTypeDeletePayload'
  errors: Array<Error>
  packageAssetType?: Maybe<PackageAssetType>
}

/** An edge in a connection. */
export type PackageAssetTypeEdge = {
  __typename?: 'PackageAssetTypeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<PackageAssetType>
}

export type PackageAssetTypeFilters = {
  assetTypeIdEq?: InputMaybe<Scalars['ID']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  packageIdEq?: InputMaybe<Scalars['ID']['input']>
}

/** Autogenerated return type of PackageAssetTypeUpdate. */
export type PackageAssetTypeUpdatePayload = {
  __typename?: 'PackageAssetTypeUpdatePayload'
  errors: Array<Error>
  packageAssetType?: Maybe<PackageAssetType>
}

export type PackageAttributes = {
  availableToEvents: Scalars['Boolean']['input']
  description: Scalars['String']['input']
  displayOnWebsite: Scalars['Boolean']['input']
  name: Scalars['String']['input']
  rateCents: Scalars['Int']['input']
}

/** The connection type for Package. */
export type PackageConnection = {
  __typename?: 'PackageConnection'
  /** A list of edges. */
  edges: Array<PackageEdge>
  /** A list of nodes. */
  nodes: Array<Package>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of PackageCreate. */
export type PackageCreatePayload = {
  __typename?: 'PackageCreatePayload'
  errors: Array<Error>
  package?: Maybe<Package>
}

/** Autogenerated return type of PackageDelete. */
export type PackageDeletePayload = {
  __typename?: 'PackageDeletePayload'
  errors: Array<Error>
  package?: Maybe<Package>
}

/** An edge in a connection. */
export type PackageEdge = {
  __typename?: 'PackageEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Package>
}

export type PackageFilters = {
  descriptionEq?: InputMaybe<Scalars['String']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
}

export type PackageOrder = {
  name?: InputMaybe<SortOrder>
}

/** Autogenerated return type of PackageUpdate. */
export type PackageUpdatePayload = {
  __typename?: 'PackageUpdatePayload'
  errors: Array<Error>
  package?: Maybe<Package>
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output']
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>
}

export type PortfolioPage = {
  __typename?: 'PortfolioPage'
  body?: Maybe<Scalars['String']['output']>
  company: Company
  description?: Maybe<Scalars['String']['output']>
  enabled: Scalars['Boolean']['output']
  event: Event
  id: Scalars['ID']['output']
  publicLink?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type PortfolioPageAttributes = {
  body: Scalars['String']['input']
  description?: InputMaybe<Scalars['String']['input']>
  enabled: Scalars['Boolean']['input']
  eventId: Scalars['ID']['input']
  slug?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
}

/** The connection type for PortfolioPage. */
export type PortfolioPageConnection = {
  __typename?: 'PortfolioPageConnection'
  /** A list of edges. */
  edges: Array<PortfolioPageEdge>
  /** A list of nodes. */
  nodes: Array<PortfolioPage>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of PortfolioPageCreate. */
export type PortfolioPageCreatePayload = {
  __typename?: 'PortfolioPageCreatePayload'
  errors: Array<Error>
  portfolioPage?: Maybe<PortfolioPage>
}

/** Autogenerated return type of PortfolioPageDelete. */
export type PortfolioPageDeletePayload = {
  __typename?: 'PortfolioPageDeletePayload'
  errors: Array<Error>
  portfolioPage?: Maybe<PortfolioPage>
}

/** An edge in a connection. */
export type PortfolioPageEdge = {
  __typename?: 'PortfolioPageEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<PortfolioPage>
}

export type PortfolioPageFilters = {
  enabledEq?: InputMaybe<Scalars['Boolean']['input']>
  eventIdEq?: InputMaybe<Scalars['ID']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  slugCont?: InputMaybe<Scalars['String']['input']>
  titleCont?: InputMaybe<Scalars['String']['input']>
}

export type PortfolioPageOrder = {
  slug?: InputMaybe<SortOrder>
  title?: InputMaybe<SortOrder>
}

/** Autogenerated return type of PortfolioPageUpdate. */
export type PortfolioPageUpdatePayload = {
  __typename?: 'PortfolioPageUpdatePayload'
  errors: Array<Error>
  portfolioPage?: Maybe<PortfolioPage>
}

export type Product = AssetType | Package | RowItem | Vehicle

export type ProductCategory = {
  __typename?: 'ProductCategory'
  category: Category
  company: Company
  id: Scalars['ID']['output']
  product: Product
}

export type ProductCategoryAttributes = {
  categoryId: Scalars['ID']['input']
  productId: Scalars['ID']['input']
  productType: ProductCategoryProduct
}

/** The connection type for ProductCategory. */
export type ProductCategoryConnection = {
  __typename?: 'ProductCategoryConnection'
  /** A list of edges. */
  edges: Array<ProductCategoryEdge>
  /** A list of nodes. */
  nodes: Array<ProductCategory>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of ProductCategoryCreate. */
export type ProductCategoryCreatePayload = {
  __typename?: 'ProductCategoryCreatePayload'
  errors: Array<Error>
  productCategory?: Maybe<ProductCategory>
}

/** Autogenerated return type of ProductCategoryDelete. */
export type ProductCategoryDeletePayload = {
  __typename?: 'ProductCategoryDeletePayload'
  errors: Array<Error>
  productCategory?: Maybe<ProductCategory>
}

/** An edge in a connection. */
export type ProductCategoryEdge = {
  __typename?: 'ProductCategoryEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<ProductCategory>
}

export type ProductCategoryFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  productIdEq?: InputMaybe<Scalars['ID']['input']>
  productTypeEq?: InputMaybe<ProductCategoryProduct>
}

export enum ProductCategoryProduct {
  AssetType = 'AssetType',
  Package = 'Package',
}

export enum ProductMultiplierProductType {
  AssetType = 'AssetType',
  Package = 'Package',
}

export type ProductMultiplierType = {
  __typename?: 'ProductMultiplierType'
  company: Company
  id: Scalars['ID']['output']
  multiplierType: MultiplierType
  product: Product
}

export type ProductMultiplierTypeAttributes = {
  multiplierTypeId: Scalars['ID']['input']
  productId: Scalars['ID']['input']
  productType: ProductMultiplierProductType
}

/** The connection type for ProductMultiplierType. */
export type ProductMultiplierTypeConnection = {
  __typename?: 'ProductMultiplierTypeConnection'
  /** A list of edges. */
  edges: Array<ProductMultiplierTypeEdge>
  /** A list of nodes. */
  nodes: Array<ProductMultiplierType>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of ProductMultiplierTypeCreate. */
export type ProductMultiplierTypeCreatePayload = {
  __typename?: 'ProductMultiplierTypeCreatePayload'
  errors: Array<Error>
  productMultiplierType?: Maybe<ProductMultiplierType>
}

/** Autogenerated return type of ProductMultiplierTypeDelete. */
export type ProductMultiplierTypeDeletePayload = {
  __typename?: 'ProductMultiplierTypeDeletePayload'
  errors: Array<Error>
  productMultiplierType?: Maybe<ProductMultiplierType>
}

/** An edge in a connection. */
export type ProductMultiplierTypeEdge = {
  __typename?: 'ProductMultiplierTypeEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<ProductMultiplierType>
}

export type ProductMultiplierTypeFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  productIdEq?: InputMaybe<Scalars['ID']['input']>
  productTypeEq?: InputMaybe<ProductMultiplierProductType>
}

export type ProductSpecification = {
  __typename?: 'ProductSpecification'
  company: Company
  id: Scalars['ID']['output']
  product: Product
  specification: Specification
  value?: Maybe<Scalars['String']['output']>
}

export type ProductSpecificationAttributes = {
  productId: Scalars['ID']['input']
  productType: ProductCategoryProduct
  specification: Scalars['String']['input']
  value: Scalars['String']['input']
}

/** The connection type for ProductSpecification. */
export type ProductSpecificationConnection = {
  __typename?: 'ProductSpecificationConnection'
  /** A list of edges. */
  edges: Array<ProductSpecificationEdge>
  /** A list of nodes. */
  nodes: Array<ProductSpecification>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  specifications: Array<Scalars['String']['output']>
}

/** Autogenerated return type of ProductSpecificationCreate. */
export type ProductSpecificationCreatePayload = {
  __typename?: 'ProductSpecificationCreatePayload'
  errors: Array<Error>
  productSpecification?: Maybe<ProductSpecification>
}

/** Autogenerated return type of ProductSpecificationDelete. */
export type ProductSpecificationDeletePayload = {
  __typename?: 'ProductSpecificationDeletePayload'
  errors: Array<Error>
  productSpecification?: Maybe<ProductSpecification>
}

/** An edge in a connection. */
export type ProductSpecificationEdge = {
  __typename?: 'ProductSpecificationEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<ProductSpecification>
}

export type ProductSpecificationFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  productIdEq?: InputMaybe<Scalars['ID']['input']>
  productTypeEq?: InputMaybe<ProductCategoryProduct>
}

export type Query = {
  __typename?: 'Query'
  accessories: AccessoryConnection
  accommodations: AccommodationConnection
  assetCases: AssetCaseConnection
  assetTypeMaintenanceSchedules: AssetTypeMaintenanceScheduleConnection
  assetTypes: AssetTypeConnection
  assets: AssetConnection
  attachments: AttachmentConnection
  barcodes: BarcodeConnection
  categories: CategoryConnection
  clientTypes: ClientTypeConnection
  clients: ClientConnection
  companies: CompanyConnection
  companyUsers: CompanyUserConnection
  currentUser: User
  customFieldValues: CustomFieldValueConnection
  customFields: CustomFieldConnection
  documentTypes: DocumentTypeConnection
  documents: DocumentConnection
  events: EventConnection
  featureRequests: FeatureRequestConnection
  integrationProviderCategories: Array<IntegrationProviderCategory>
  integrationProviders: Array<IntegrationProvider>
  integrations: Array<Integration>
  maintenanceEvents: MaintenanceEventConnection
  maintenanceSchedules: MaintenanceScheduleConnection
  maintenanceTypeTasks: MaintenanceTypeTaskConnection
  maintenanceTypes: MaintenanceTypeConnection
  multiplierTypes: MultiplierTypeConnection
  mystroTests: Array<MystroTest>
  notifications: NotificationConnection
  packageAssetTypes: PackageAssetTypeConnection
  packages: PackageConnection
  portfolioPages: PortfolioPageConnection
  productCategories: ProductCategoryConnection
  productMultiplierTypes: ProductMultiplierTypeConnection
  productSpecifications: ProductSpecificationConnection
  rowItems: RowItemConnection
  shiftRoles: ShiftRoleConnection
  shifts: ShiftConnection
  taxRates: TaxRateConnection
  users: UserConnection
  vehicles: VehicleConnection
  venueContact?: Maybe<VenueContact>
  venues: VenueConnection
  warehouses: WarehouseConnection
  websitePages: WebsitePageConnection
}

export type QueryAccessoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<AccessoryFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryAccommodationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<AccommodationFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryAssetCasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<AssetCaseFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<AssetCaseOrder>
}

export type QueryAssetTypeMaintenanceSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<AssetTypeMaintenanceScheduleFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryAssetTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<AssetTypeFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<AssetTypeOrder>
}

export type QueryAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<AssetFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<AssetOrder>
}

export type QueryAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters: AttachmentFilters
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryBarcodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<BarcodeFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<BarcodeOrder>
}

export type QueryCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<CategoryFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<CategoryOrder>
}

export type QueryClientTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<ClientTypeFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<ClientTypeOrder>
}

export type QueryClientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<ClientFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<ClientOrder>
}

export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<CompanyFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCompanyUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<CompanyUserFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCustomFieldValuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<CustomFieldValueFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCustomFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<CustomFieldFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryDocumentTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<DocumentTypeFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<DocumentTypeOrder>
}

export type QueryDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<DocumentFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<DocumentOrder>
}

export type QueryEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<EventFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<EventOrder>
}

export type QueryFeatureRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<FeatureRequestFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<FeatureRequestOrder>
}

export type QueryIntegrationProviderCategoriesArgs = {
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<IntegrationProviderCategoryFilters>
  order?: InputMaybe<IntegrationProviderCategoryOrder>
}

export type QueryIntegrationProvidersArgs = {
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<IntegrationProviderFilters>
  order?: InputMaybe<IntegrationProviderOrder>
}

export type QueryIntegrationsArgs = {
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<IntegrationFilters>
}

export type QueryMaintenanceEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<MaintenanceEventFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<MaintenanceEventOrder>
}

export type QueryMaintenanceSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<MaintenanceScheduleFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryMaintenanceTypeTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<MaintenanceTypeTaskFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryMaintenanceTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<MaintenanceTypeFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<MaintenanceTypeOrder>
}

export type QueryMultiplierTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<MultiplierTypeFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<MultiplierTypeOrder>
}

export type QueryMystroTestsArgs = {
  companyId: Scalars['ID']['input']
}

export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<NotificationFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPackageAssetTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<PackageAssetTypeFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<PackageFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<PackageOrder>
}

export type QueryPortfolioPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<PortfolioPageFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<PortfolioPageOrder>
}

export type QueryProductCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<ProductCategoryFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryProductMultiplierTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<ProductMultiplierTypeFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryProductSpecificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<ProductSpecificationFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryRowItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<RowItemFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<RowItemOrder>
}

export type QueryShiftRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<ShiftRoleFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryShiftsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<ShiftFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<ShiftOrder>
}

export type QueryTaxRatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<TaxRateFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<UserFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type QueryVehiclesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<VehicleFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<VehicleOrder>
}

export type QueryVenueContactArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type QueryVenuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<VenueFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<VenueOrder>
}

export type QueryWarehousesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<WarehouseFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<WarehouseOrder>
}

export type QueryWebsitePagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<WebsitePageFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  order?: InputMaybe<WebsitePageOrder>
}

export type RemoteSubscription = {
  __typename?: 'RemoteSubscription'
  documentTypeUpdated: UpdatedPayload
}

export type RemoteSubscriptionDocumentTypeUpdatedArgs = {
  companyId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type RowItem = {
  __typename?: 'RowItem'
  company: Company
  documentCategory?: Maybe<Category>
  documents: Array<Document>
  events: Array<Event>
  id: Scalars['ID']['output']
  images: Array<Blob>
  name: Scalars['String']['output']
  priceCents?: Maybe<Scalars['Int']['output']>
  revenue?: Maybe<Scalars['Float']['output']>
}

export type RowItemAttributes = {
  name: Scalars['String']['input']
  priceCents: Scalars['Int']['input']
}

/** The connection type for RowItem. */
export type RowItemConnection = {
  __typename?: 'RowItemConnection'
  /** A list of edges. */
  edges: Array<RowItemEdge>
  /** A list of nodes. */
  nodes: Array<RowItem>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of RowItemCreate. */
export type RowItemCreatePayload = {
  __typename?: 'RowItemCreatePayload'
  errors: Array<Error>
  rowItem?: Maybe<RowItem>
}

/** Autogenerated return type of RowItemDelete. */
export type RowItemDeletePayload = {
  __typename?: 'RowItemDeletePayload'
  errors: Array<Error>
  rowItem?: Maybe<RowItem>
}

/** An edge in a connection. */
export type RowItemEdge = {
  __typename?: 'RowItemEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<RowItem>
}

export type RowItemFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
}

export type RowItemOrder = {
  name?: InputMaybe<SortOrder>
}

/** Autogenerated return type of RowItemUpdate. */
export type RowItemUpdatePayload = {
  __typename?: 'RowItemUpdatePayload'
  errors: Array<Error>
  rowItem?: Maybe<RowItem>
}

export type Shift = {
  __typename?: 'Shift'
  company: Company
  dayrateCents: Scalars['Int']['output']
  event: Event
  finish: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  rateCents: Scalars['Int']['output']
  shiftRole?: Maybe<ShiftRole>
  start: Scalars['ISO8601DateTime']['output']
  user?: Maybe<User>
}

export type ShiftAttributes = {
  dayrateCents?: InputMaybe<Scalars['Int']['input']>
  eventId: Scalars['ID']['input']
  finish: Scalars['ISO8601DateTime']['input']
  rateCents?: InputMaybe<Scalars['Int']['input']>
  shiftRoleId?: InputMaybe<Scalars['ID']['input']>
  start: Scalars['ISO8601DateTime']['input']
  userId?: InputMaybe<Scalars['ID']['input']>
}

/** The connection type for Shift. */
export type ShiftConnection = {
  __typename?: 'ShiftConnection'
  /** A list of edges. */
  edges: Array<ShiftEdge>
  /** A list of nodes. */
  nodes: Array<Shift>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of ShiftCreate. */
export type ShiftCreatePayload = {
  __typename?: 'ShiftCreatePayload'
  errors: Array<Error>
  shift?: Maybe<Shift>
}

/** Autogenerated return type of ShiftDelete. */
export type ShiftDeletePayload = {
  __typename?: 'ShiftDeletePayload'
  errors: Array<Error>
  shift?: Maybe<Shift>
}

/** An edge in a connection. */
export type ShiftEdge = {
  __typename?: 'ShiftEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Shift>
}

export type ShiftFilters = {
  eventIdEq?: InputMaybe<Scalars['ID']['input']>
  finishGteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  shiftRoleNameEq?: InputMaybe<Scalars['String']['input']>
  startLteq?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  userDisplayNameCont?: InputMaybe<Scalars['String']['input']>
  userIdEq?: InputMaybe<Scalars['ID']['input']>
}

export type ShiftOrder = {
  finish?: InputMaybe<SortOrder>
  start?: InputMaybe<SortOrder>
}

export type ShiftRole = {
  __typename?: 'ShiftRole'
  company: Company
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  shifts: Array<Shift>
}

/** The connection type for ShiftRole. */
export type ShiftRoleConnection = {
  __typename?: 'ShiftRoleConnection'
  /** A list of edges. */
  edges: Array<ShiftRoleEdge>
  /** A list of nodes. */
  nodes: Array<ShiftRole>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type ShiftRoleEdge = {
  __typename?: 'ShiftRoleEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<ShiftRole>
}

export type ShiftRoleFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
  nameEq?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of ShiftUpdate. */
export type ShiftUpdatePayload = {
  __typename?: 'ShiftUpdatePayload'
  errors: Array<Error>
  shift?: Maybe<Shift>
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc',
}

export type Specification = {
  __typename?: 'Specification'
  company: Company
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type StripePayment = {
  __typename?: 'StripePayment'
  company: Company
  event: Event
  id: Scalars['ID']['output']
  state?: Maybe<Scalars['String']['output']>
}

export type Subscription = {
  __typename?: 'Subscription'
  company: Company
  id: Scalars['ID']['output']
  kitCount: Scalars['Int']['output']
  state: Scalars['String']['output']
  stripePriceId: Scalars['String']['output']
  stripeUrl: Scalars['String']['output']
}

export enum Task {
  Replacement = 'replacement',
  Test = 'test',
}

export type TaxRate = {
  __typename?: 'TaxRate'
  company: Company
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  rate: Scalars['Float']['output']
}

export type TaxRateAttributes = {
  name: Scalars['String']['input']
  rate: Scalars['Float']['input']
}

/** The connection type for TaxRate. */
export type TaxRateConnection = {
  __typename?: 'TaxRateConnection'
  /** A list of edges. */
  edges: Array<TaxRateEdge>
  /** A list of nodes. */
  nodes: Array<TaxRate>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of TaxRateCreate. */
export type TaxRateCreatePayload = {
  __typename?: 'TaxRateCreatePayload'
  errors: Array<Error>
  taxRate?: Maybe<TaxRate>
}

/** Autogenerated return type of TaxRateDelete. */
export type TaxRateDeletePayload = {
  __typename?: 'TaxRateDeletePayload'
  errors: Array<Error>
  taxRate?: Maybe<TaxRate>
}

/** An edge in a connection. */
export type TaxRateEdge = {
  __typename?: 'TaxRateEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<TaxRate>
}

export type TaxRateFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of TaxRateUpdate. */
export type TaxRateUpdatePayload = {
  __typename?: 'TaxRateUpdatePayload'
  errors: Array<Error>
  taxRate?: Maybe<TaxRate>
}

/** Autogenerated return type of Updated. */
export type UpdatedPayload = {
  __typename?: 'UpdatedPayload'
  documentType: DocumentType
}

export type User = {
  __typename?: 'User'
  avatar?: Maybe<Blob>
  companies: Array<Company>
  companyUsers: Array<CompanyUser>
  crew: Scalars['Boolean']['output']
  displayName?: Maybe<Scalars['String']['output']>
  email: Scalars['String']['output']
  events: Array<Event>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  notifications: NotificationConnection
  phone?: Maybe<Scalars['String']['output']>
  shifts: Array<Shift>
}

export type UserNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  companyId: Scalars['ID']['input']
  filters?: InputMaybe<NotificationFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type UserShiftsArgs = {
  filters?: InputMaybe<ShiftFilters>
}

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection'
  /** A list of edges. */
  edges: Array<UserEdge>
  /** A list of nodes. */
  nodes: Array<User>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<User>
}

export type UserFilters = {
  crewEq?: InputMaybe<Scalars['Boolean']['input']>
  displayNameCont?: InputMaybe<Scalars['String']['input']>
  emailCont?: InputMaybe<Scalars['String']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  phoneCont?: InputMaybe<Scalars['String']['input']>
}

export type Vehicle = {
  __typename?: 'Vehicle'
  cabSize?: Maybe<Scalars['Int']['output']>
  company: Company
  costCents?: Maybe<Scalars['Int']['output']>
  documents: Array<Document>
  events: Array<Event>
  height?: Maybe<Scalars['Float']['output']>
  id: Scalars['ID']['output']
  images: Array<Blob>
  length?: Maybe<Scalars['Float']['output']>
  manufacturer?: Maybe<Scalars['String']['output']>
  mileageCents?: Maybe<Scalars['Int']['output']>
  model?: Maybe<Scalars['String']['output']>
  multiplierTypes: Array<MultiplierType>
  name: Scalars['String']['output']
  notes?: Maybe<Scalars['String']['output']>
  payload?: Maybe<Scalars['Float']['output']>
  productAttachments: Array<Blob>
  productSpecifications: Array<ProductSpecification>
  rateCents?: Maybe<Scalars['Int']['output']>
  registration?: Maybe<Scalars['String']['output']>
  volume?: Maybe<Scalars['Float']['output']>
  warehouse?: Maybe<Warehouse>
  width?: Maybe<Scalars['Float']['output']>
}

export type VehicleAttributes = {
  cabSize: Scalars['Int']['input']
  costCents: Scalars['Int']['input']
  height: Scalars['Float']['input']
  length: Scalars['Float']['input']
  manufacturer: Scalars['String']['input']
  mileageCents: Scalars['Int']['input']
  model: Scalars['String']['input']
  notes: Scalars['String']['input']
  payload: Scalars['Float']['input']
  rateCents: Scalars['Int']['input']
  registration: Scalars['String']['input']
  warehouseId: Scalars['ID']['input']
  width: Scalars['Float']['input']
}

/** The connection type for Vehicle. */
export type VehicleConnection = {
  __typename?: 'VehicleConnection'
  /** A list of edges. */
  edges: Array<VehicleEdge>
  manufacturers: Array<Scalars['String']['output']>
  models: Array<Scalars['String']['output']>
  /** A list of nodes. */
  nodes: Array<Vehicle>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of VehicleCreate. */
export type VehicleCreatePayload = {
  __typename?: 'VehicleCreatePayload'
  errors: Array<Error>
  vehicle?: Maybe<Vehicle>
}

/** Autogenerated return type of VehicleDelete. */
export type VehicleDeletePayload = {
  __typename?: 'VehicleDeletePayload'
  errors: Array<Error>
  vehicle?: Maybe<Vehicle>
}

/** An edge in a connection. */
export type VehicleEdge = {
  __typename?: 'VehicleEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Vehicle>
}

export type VehicleFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  manufacturerCont?: InputMaybe<Scalars['String']['input']>
  modelCont?: InputMaybe<Scalars['String']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
}

export type VehicleOrder = {
  manufacturer?: InputMaybe<SortOrder>
  model?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  registration?: InputMaybe<SortOrder>
}

/** Autogenerated return type of VehicleUpdate. */
export type VehicleUpdatePayload = {
  __typename?: 'VehicleUpdatePayload'
  errors: Array<Error>
  vehicle?: Maybe<Vehicle>
}

export type Venue = {
  __typename?: 'Venue'
  address?: Maybe<Scalars['String']['output']>
  address1?: Maybe<Scalars['String']['output']>
  address2?: Maybe<Scalars['String']['output']>
  address3?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  company: Company
  county?: Maybe<Scalars['String']['output']>
  customFieldValues: CustomFieldValueConnection
  events: Array<Event>
  id: Scalars['ID']['output']
  map?: Maybe<Blob>
  name: Scalars['String']['output']
  notes?: Maybe<Scalars['String']['output']>
  postcode?: Maybe<Scalars['String']['output']>
  venueContacts: VenueContactConnection
}

export type VenueCustomFieldValuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<CustomFieldValueFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type VenueVenueContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<VenueContactFilters>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type VenueAttributes = {
  address1?: InputMaybe<Scalars['String']['input']>
  address2?: InputMaybe<Scalars['String']['input']>
  address3?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  county?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  notes?: InputMaybe<Scalars['String']['input']>
  postcode?: InputMaybe<Scalars['String']['input']>
}

/** The connection type for Venue. */
export type VenueConnection = {
  __typename?: 'VenueConnection'
  /** A list of edges. */
  edges: Array<VenueEdge>
  /** A list of nodes. */
  nodes: Array<Venue>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export type VenueContact = {
  __typename?: 'VenueContact'
  color: Color
  company: Company
  contactType: VenueContactContact
  email?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  phone?: Maybe<Scalars['String']['output']>
  user?: Maybe<User>
  venue: Venue
}

export type VenueContactAttributes = {
  contactType: VenueContactContact
  email?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['ID']['input']>
  venueId: Scalars['ID']['input']
}

/** The connection type for VenueContact. */
export type VenueContactConnection = {
  __typename?: 'VenueContactConnection'
  /** A list of edges. */
  edges: Array<VenueContactEdge>
  /** A list of nodes. */
  nodes: Array<VenueContact>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

export enum VenueContactContact {
  Facilities = 'facilities',
  Management = 'management',
  Other = 'other',
  Security = 'security',
  Technical = 'technical',
}

/** Autogenerated return type of VenueContactCreate. */
export type VenueContactCreatePayload = {
  __typename?: 'VenueContactCreatePayload'
  errors: Array<Error>
  venueContact?: Maybe<VenueContact>
}

/** Autogenerated return type of VenueContactDelete. */
export type VenueContactDeletePayload = {
  __typename?: 'VenueContactDeletePayload'
  errors: Array<Error>
  venueContact?: Maybe<VenueContact>
}

/** An edge in a connection. */
export type VenueContactEdge = {
  __typename?: 'VenueContactEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<VenueContact>
}

export type VenueContactFilters = {
  contactTypeEq?: InputMaybe<Scalars['String']['input']>
  emailCont?: InputMaybe<Scalars['String']['input']>
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
  phoneCont?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of VenueContactUpdate. */
export type VenueContactUpdatePayload = {
  __typename?: 'VenueContactUpdatePayload'
  errors: Array<Error>
  venueContact?: Maybe<VenueContact>
}

/** Autogenerated return type of VenueCreate. */
export type VenueCreatePayload = {
  __typename?: 'VenueCreatePayload'
  errors: Array<Error>
  venue?: Maybe<Venue>
}

/** Autogenerated return type of VenueDelete. */
export type VenueDeletePayload = {
  __typename?: 'VenueDeletePayload'
  errors: Array<Error>
  venue?: Maybe<Venue>
}

/** An edge in a connection. */
export type VenueEdge = {
  __typename?: 'VenueEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Venue>
}

export type VenueFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
}

export type VenueOrder = {
  name?: InputMaybe<SortOrder>
}

/** Autogenerated return type of VenueUpdate. */
export type VenueUpdatePayload = {
  __typename?: 'VenueUpdatePayload'
  errors: Array<Error>
  venue?: Maybe<Venue>
}

export type Warehouse = {
  __typename?: 'Warehouse'
  address?: Maybe<Scalars['String']['output']>
  address1?: Maybe<Scalars['String']['output']>
  address2?: Maybe<Scalars['String']['output']>
  address3?: Maybe<Scalars['String']['output']>
  assetCases: Array<AssetCase>
  assets: Array<Asset>
  availablePackages?: Maybe<Array<Package>>
  availableVehicles?: Maybe<Array<Vehicle>>
  city?: Maybe<Scalars['String']['output']>
  company: Company
  county?: Maybe<Scalars['String']['output']>
  events: Array<Event>
  id: Scalars['ID']['output']
  locations: Array<Scalars['String']['output']>
  name: Scalars['String']['output']
  postcode?: Maybe<Scalars['String']['output']>
  vehicles: Array<Vehicle>
}

export type WarehouseAttributes = {
  address1?: InputMaybe<Scalars['String']['input']>
  address2?: InputMaybe<Scalars['String']['input']>
  address3?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  county?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  postcode?: InputMaybe<Scalars['String']['input']>
}

/** The connection type for Warehouse. */
export type WarehouseConnection = {
  __typename?: 'WarehouseConnection'
  /** A list of edges. */
  edges: Array<WarehouseEdge>
  /** A list of nodes. */
  nodes: Array<Warehouse>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** Autogenerated return type of WarehouseCreate. */
export type WarehouseCreatePayload = {
  __typename?: 'WarehouseCreatePayload'
  errors: Array<Error>
  warehouse?: Maybe<Warehouse>
}

/** Autogenerated return type of WarehouseDelete. */
export type WarehouseDeletePayload = {
  __typename?: 'WarehouseDeletePayload'
  errors: Array<Error>
  warehouse?: Maybe<Warehouse>
}

/** An edge in a connection. */
export type WarehouseEdge = {
  __typename?: 'WarehouseEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Warehouse>
}

export type WarehouseFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
}

export type WarehouseOrder = {
  name?: InputMaybe<SortOrder>
}

/** Autogenerated return type of WarehouseUpdate. */
export type WarehouseUpdatePayload = {
  __typename?: 'WarehouseUpdatePayload'
  errors: Array<Error>
  warehouse?: Maybe<Warehouse>
}

export type Website = {
  __typename?: 'Website'
  company: Company
  id: Scalars['ID']['output']
  template: Scalars['String']['output']
  websiteComponents: Array<WebsiteComponent>
  websitePages: Array<WebsitePage>
}

export type WebsiteComponent = {
  __typename?: 'WebsiteComponent'
  company: Company
  componentType?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  position: Scalars['String']['output']
  slug?: Maybe<Scalars['String']['output']>
  template?: Maybe<Scalars['String']['output']>
  website: Website
}

export type WebsitePage = {
  __typename?: 'WebsitePage'
  company: Company
  content?: Maybe<Scalars['JSON']['output']>
  displayOrder: Scalars['Int']['output']
  id: Scalars['ID']['output']
  images: Array<Blob>
  name: Scalars['String']['output']
  position: Scalars['String']['output']
  preview: Blob
  slug: Scalars['String']['output']
}

/** The connection type for WebsitePage. */
export type WebsitePageConnection = {
  __typename?: 'WebsitePageConnection'
  /** A list of edges. */
  edges: Array<WebsitePageEdge>
  /** A list of nodes. */
  nodes: Array<WebsitePage>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
}

/** An edge in a connection. */
export type WebsitePageEdge = {
  __typename?: 'WebsitePageEdge'
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<WebsitePage>
}

export type WebsitePageFilters = {
  idEq?: InputMaybe<Scalars['ID']['input']>
  nameCont?: InputMaybe<Scalars['String']['input']>
}

export type WebsitePageOrder = {
  name?: InputMaybe<SortOrder>
}

export type XeroReference = {
  __typename?: 'XeroReference'
  company: Company
  id: Scalars['ID']['output']
  resource: Array<XeroReferenceObject>
  xeroId: Scalars['String']['output']
  xeroTenant: XeroTenant
}

export type XeroReferenceObject = Client | Document

export type XeroTenant = {
  __typename?: 'XeroTenant'
  company: Company
  id: Scalars['ID']['output']
  tenantId: Scalars['String']['output']
  tenantName: Scalars['String']['output']
}
